(() => {
var $c1e53a68f7465bc4$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return n(r, t, e, u, a, c);
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, c) {
        return 6 === n.a ? n.f(r, t, e, u, a, c) : n(r)(t)(e)(u)(a)(c);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, h(t, r);
    }), u = F2(function(n, r) {
        return r[n];
    }), a = F3(function(n, r, t) {
        for(var e = t.length, u = Array(e), a = 0; e > a; a++)u[a] = t[a];
        return u[n] = r, u;
    }), c = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u; u++)r = A2(n, t[u], r);
        return r;
    }), i = F3(function(n, r, t) {
        for(var e = t.length - 1; e >= 0; e--)r = A2(n, t[e], r);
        return r;
    }), f = F2(function(n, r) {
        for(var t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = n(r[u]);
        return e;
    });
    function o(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function b(n, r) {
        for(var t, e = [], u = s(n, r, 0, e); u && (t = e.pop()); u = s(t.a, t.b, 0, e));
        return u;
    }
    function s(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && o(5), !1;
        if (t > 100) return e.push(h(n, r)), !0;
        for(var u in 0 > n.$ && (n = Lr(n), r = Lr(r)), n)if (!s(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var v = F2(function(n, r) {
        return !b(n, r);
    });
    function d(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = d(n.a, r.a)) || (t = d(n.b, r.b)) ? t : d(n.c, r.c);
        for(; n.b && r.b && !(t = d(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        var t = d(n, r);
        return 0 > t ? Sr : t ? Tr : Rr;
    });
    function h(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function $(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function p(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var g = F2(m);
    function m(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = y(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = y(n.a, r);
        return t;
    }
    var w = {
        $: 0
    };
    function y(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var A = F2(y);
    function _(n) {
        for(var r = w, t = n.length; t--;)r = y(n[t], r);
        return r;
    }
    function k(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var N = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return _(e);
    }), j = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? o(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), O = Math.ceil, L = Math.floor, C = Math.round, R = Math.log, T = isNaN, S = F2(function(n, r) {
        return n + r;
    }), E = F2(function(n, r) {
        return n + r;
    }), J = F2(function(n, r) {
        for(var t = [], e = r.length, u = 0; e > u;){
            var a = r[u], c = r.charCodeAt(u);
            u++, 55296 > c || c > 56319 || (a += r[u], u++), n(a) && t.push(a);
        }
        return t.join("");
    }), M = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u;){
            var a = t[u], c = t.charCodeAt(u);
            u++, 55296 > c || c > 56319 || (a += t[u], u++), r = A2(n, a, r);
        }
        return r;
    }), x = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, u, r);
        }
        return r;
    }), U = F2(function(n, r) {
        return r.split(n);
    }), B = F2(function(n, r) {
        return r.join(n);
    });
    function D(n) {
        return n + "";
    }
    function I(n) {
        return {
            $: 2,
            b: n
        };
    }
    var F = I(function(n) {
        return "number" != typeof n ? X("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Ur(n) : !isFinite(n) || n % 1 ? X("an INT", n) : Ur(n);
    }), Q = (I(function(n) {
        return "boolean" == typeof n ? Ur(n) : X("a BOOL", n);
    }), I(function(n) {
        return "number" == typeof n ? Ur(n) : X("a FLOAT", n);
    }), I(function(n) {
        return Ur(n);
    }), I(function(n) {
        return "string" == typeof n ? Ur(n) : n instanceof String ? Ur(n + "") : X("a STRING", n);
    })), V = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function q(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var P = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), Y = F2(function(n, r) {
        return q(n, [
            r
        ]);
    }), z = F3(function(n, r, t) {
        return q(n, [
            r,
            t
        ]);
    }), G = F2(function(n, r) {
        return Z(n, r);
    });
    function Z(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Ur(n.c) : X("null", r);
            case 3:
                return H(r) ? K(n.b, r, _) : X("a LIST", r);
            case 4:
                return H(r) ? K(n.b, r, W) : X("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return X("an OBJECT with a field named `" + t + "`", r);
                var e = Z(n.b, r[t]);
                return gt(e) ? e : Er(A2(Mr, t, e.a));
            case 7:
                var u = n.e;
                return H(r) ? r.length > u ? (e = Z(n.b, r[u]), gt(e) ? e : Er(A2(xr, u, e.a))) : X("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : X("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || H(r)) return X("an OBJECT", r);
                var a = w;
                for(var c in r)if (r.hasOwnProperty(c)) {
                    if (e = Z(n.b, r[c]), !gt(e)) return Er(A2(Mr, c, e.a));
                    a = y(h(c, e.a), a);
                }
                return Ur(Hr(a));
            case 9:
                for(var i = n.f, f = n.g, o = 0; f.length > o; o++){
                    if (e = Z(f[o], r), !gt(e)) return e;
                    i = i(e.a);
                }
                return Ur(i);
            case 10:
                return e = Z(n.b, r), gt(e) ? Z(n.h(e.a), r) : e;
            case 11:
                for(var b = w, s = n.g; s.b; s = s.b){
                    if (e = Z(s.a, r), gt(e)) return e;
                    b = y(e.a, b);
                }
                return Er(Br(Hr(b)));
            case 1:
                return Er(A2(Jr, n.a, r));
            case 0:
                return Ur(n.a);
        }
    }
    function K(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var c = Z(n, r[a]);
            if (!gt(c)) return Er(A2(xr, a, c.a));
            u[a] = c.a;
        }
        return Ur(t(u));
    }
    function H(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function W(n) {
        return A2(pt, n.length, function(r) {
            return n[r];
        });
    }
    function X(n, r) {
        return Er(A2(Jr, "Expecting " + n, r));
    }
    function nn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return nn(n.b, r.b);
            case 6:
                return n.d === r.d && nn(n.b, r.b);
            case 7:
                return n.e === r.e && nn(n.b, r.b);
            case 9:
                return n.f === r.f && rn(n.g, r.g);
            case 10:
                return n.h === r.h && nn(n.b, r.b);
            case 11:
                return rn(n.g, r.g);
        }
    }
    function rn(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!nn(n[e], r[e])) return !1;
        return !0;
    }
    function tn(n) {
        return n;
    }
    var en = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function un(n) {
        return F2(function(r, t) {
            return t.push(n(r)), t;
        });
    }
    function an(n) {
        return {
            $: 0,
            a: n
        };
    }
    function cn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var fn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), on = 0;
    function bn(n) {
        var r = {
            $: 0,
            e: on++,
            f: n,
            g: null,
            h: []
        };
        return $n(r), r;
    }
    function sn(n) {
        return cn(function(r) {
            r(an(bn(n)));
        });
    }
    function vn(n, r) {
        n.h.push(r), $n(n);
    }
    var dn = F2(function(n, r) {
        return cn(function(t) {
            vn(n, r), t(an(0));
        });
    }), ln = !1, hn = [];
    function $n(n) {
        if (hn.push(n), !ln) {
            for(ln = !0; n = hn.shift();)pn(n);
            ln = !1;
        }
    }
    function pn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, $n(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var gn = {};
    function mn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function wn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, c = n.f;
        function i(n) {
            return A2(fn, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, t, i, n) : a && c ? A4(e, t, i.i, i.j, n) : A3(e, t, a ? i.i : i.j, n);
                }
            });
        }
        return t.h = bn(A2(fn, i, n.b));
    }
    var yn = F2(function(n, r) {
        return cn(function(t) {
            n.g(r), t(an(0));
        });
    }), An = F2(function(n, r) {
        return A2(dn, n.h, {
            $: 0,
            a: r
        });
    });
    function _n(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function kn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Nn, jn = [], On = !1;
    function Ln(n, r, t) {
        if (jn.push({
            p: n,
            q: r,
            r: t
        }), !On) {
            On = !0;
            for(var e; e = jn.shift();)Cn(e.p, e.q, e.r);
            On = !1;
        }
    }
    function Cn(n, r, t) {
        var e = {};
        for(var u in Rn(!0, r, e, null), Rn(!1, t, e, null), n)vn(n[u], {
            $: "fx",
            a: e[u] || {
                i: w,
                j: w
            }
        });
    }
    function Rn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? gn[r].e : gn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: w,
                        j: w
                    }, n ? t.i = y(r, t.i) : t.j = y(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var c = r.m; c.b; c = c.b)Rn(n, c.a, t, e);
                return;
            case 3:
                return void Rn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var Tn = "undefined" != typeof document ? document : {};
    function Sn(n, r) {
        n.appendChild(r);
    }
    function En(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Jn, Mn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var c = e.a;
                a += c.b || 0, u.push(c);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Yn(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), xn = Mn(void 0), Un = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var c = e.a;
                a += c.b.b || 0, u.push(c);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Yn(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), Bn = Un(void 0), Dn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), In = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Fn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), Qn = /^script$/i, Vn = /^(on|formAction$)/i, qn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Pn(n) {
        return Qn.test(n) ? "p" : n;
    }
    function Yn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var c = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? zn(c, u, a) : c[u] = a;
            } else "className" === u ? zn(r, u, a) : r[u] = a;
        }
        return r;
    }
    function zn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Gn(n, r) {
        var t = n.$;
        if (5 === t) return Gn(n.k || (n.k = n.m()), r);
        if (0 === t) return Tn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (c = Gn(e, a)).elm_event_node_ref = a, c;
        }
        if (3 === t) return Zn(c = n.h(n.g), r, n.d), c;
        var c = n.f ? Tn.createElementNS(n.f, n.c) : Tn.createElement(n.c);
        Nn && "a" == n.c && c.addEventListener("click", Nn(c)), Zn(c, r, n.d);
        for(var i = n.e, f = 0; i.length > f; f++)Sn(c, Gn(1 === t ? i[f] : i[f].b, r));
        return c;
    }
    function Zn(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Kn(n, u) : "a0" === e ? Xn(n, r, u) : "a3" === e ? Hn(n, u) : "a4" === e ? Wn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Kn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Hn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Wn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Xn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], c = e[u];
            if (a) {
                if (c) {
                    if (c.q.$ === a.$) {
                        c.q = a;
                        continue;
                    }
                    n.removeEventListener(u, c);
                }
                c = nr(r, a), n.addEventListener(u, c, Jn && {
                    passive: 2 > _t(a)
                }), e[u] = c;
            } else n.removeEventListener(u, c), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Jn = !0;
            }
        }));
    } catch (n) {}
    function nr(n, r) {
        function t(r) {
            var e = t.q, u = Z(e.a, r);
            if (gt(u)) {
                for(var a, c = _t(e), i = u.a, f = c ? 3 > c ? i.a : i.aa : i, o = 1 == c ? i.b : 3 == c && i.cd, b = (o && r.stopPropagation(), (2 == c ? i.b : 3 == c && i.ca) && r.preventDefault(), n); a = b.j;){
                    if ("function" == typeof a) f = a(f);
                    else for(var s = a.length; s--;)f = a[s](f);
                    b = b.p;
                }
                b(f, o);
            }
        }
        return t.q = r, t;
    }
    function rr(n, r) {
        return n.$ == r.$ && nn(n.a, r.a);
    }
    function tr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function er(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void tr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var c = n.l, i = r.l, f = c.length, o = f === i.length; o && f--;)o = c[f] === i[f];
                    if (o) return void (r.k = n.k);
                    r.k = r.m();
                    var b = [];
                    return er(n.k, r.k, b, 0), void (b.length > 0 && tr(t, 1, e, b));
                case 4:
                    for(var s = n.j, v = r.j, d = !1, l = n.k; 4 === l.$;)d = !0, "object" != typeof s ? s = [
                        s,
                        l.j
                    ] : s.push(l.j), l = l.k;
                    for(var h = r.k; 4 === h.$;)d = !0, "object" != typeof v ? v = [
                        v,
                        h.j
                    ] : v.push(h.j), h = h.k;
                    return d && s.length !== v.length ? void tr(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(s, v) : s === v) || tr(t, 2, e, v), void er(l, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && tr(t, 3, e, r.a));
                case 1:
                    return void ur(n, r, t, e, cr);
                case 2:
                    return void ur(n, r, t, e, ir);
                case 3:
                    if (n.h !== r.h) return void tr(t, 0, e, r);
                    var $ = ar(n.d, r.d);
                    $ && tr(t, 4, e, $);
                    var p = r.i(n.g, r.g);
                    return void (p && tr(t, 5, e, p));
            }
        }
    }
    function ur(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = ar(n.d, r.d);
            a && tr(t, 4, e, a), u(n, r, t, e);
        } else tr(t, 0, e, r);
    }
    function ar(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], c = r[u];
                a === c && "value" !== u && "checked" !== u || "a0" === t && rr(a, c) || ((e = e || {})[u] = c);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var i = ar(n[u], r[u] || {}, u);
            i && ((e = e || {})[u] = i);
        }
        for(var f in r)f in n || ((e = e || {})[f] = r[f]);
        return e;
    }
    function cr(n, r, t, e) {
        var u = n.e, a = r.e, c = u.length, i = a.length;
        c > i ? tr(t, 6, e, {
            v: i,
            i: c - i
        }) : i > c && tr(t, 7, e, {
            v: c,
            e: a
        });
        for(var f = i > c ? c : i, o = 0; f > o; o++){
            var b = u[o];
            er(b, a[o], t, ++e), e += b.b || 0;
        }
    }
    function ir(n, r, t, e) {
        for(var u = [], a = {}, c = [], i = n.e, f = r.e, o = i.length, b = f.length, s = 0, v = 0, d = e; o > s && b > v;){
            var l = (j = i[s]).a, h = (O = f[v]).a, $ = j.b, p = O.b, g = void 0, m = void 0;
            if (l !== h) {
                var w = i[s + 1], y = f[v + 1];
                if (w) {
                    var A = w.a, _ = w.b;
                    m = h === A;
                }
                if (y) {
                    var k = y.a, N = y.b;
                    g = l === k;
                }
                if (g && m) er($, N, u, ++d), or(a, u, l, p, v, c), d += $.b || 0, br(a, u, l, _, ++d), d += _.b || 0, s += 2, v += 2;
                else if (g) d++, or(a, u, h, p, v, c), er($, N, u, d), d += $.b || 0, s += 1, v += 2;
                else if (m) br(a, u, l, $, ++d), d += $.b || 0, er(_, p, u, ++d), d += _.b || 0, s += 2, v += 1;
                else {
                    if (!w || A !== k) break;
                    br(a, u, l, $, ++d), or(a, u, h, p, v, c), d += $.b || 0, er(_, N, u, ++d), d += _.b || 0, s += 2, v += 2;
                }
            } else er($, p, u, ++d), d += $.b || 0, s++, v++;
        }
        for(; o > s;){
            var j;
            d++, br(a, u, (j = i[s]).a, $ = j.b, d), d += $.b || 0, s++;
        }
        for(; b > v;){
            var O, L = L || [];
            or(a, u, (O = f[v]).a, O.b, void 0, L), v++;
        }
        (u.length > 0 || c.length > 0 || L) && tr(t, 8, e, {
            w: u,
            x: c,
            y: L
        });
    }
    var fr = "_elmW6BL";
    function or(n, r, t, e, u, a) {
        var c = n[t];
        if (!c) return a.push({
            r: u,
            A: c = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = c);
        if (1 === c.c) {
            a.push({
                r: u,
                A: c
            }), c.c = 2;
            var i = [];
            return er(c.z, e, i, c.r), c.r = u, void (c.s.s = {
                w: i,
                A: c
            });
        }
        or(n, r, t + fr, e, u, a);
    }
    function br(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var c = [];
                return er(e, a.z, c, u), void tr(r, 9, u, {
                    w: c,
                    A: a
                });
            }
            br(n, r, t + fr, e, u);
        } else {
            var i = tr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: i
            };
        }
    }
    function sr(n, r, t, e) {
        vr(n, r, t, 0, 0, r.b, e);
    }
    function vr(n, r, t, e, u, a, c) {
        for(var i = t[e], f = i.r; f === u;){
            var o = i.$;
            if (1 === o) sr(n, r.k, i.s, c);
            else if (8 === o) i.t = n, i.u = c, (b = i.s.w).length > 0 && vr(n, r, b, 0, u, a, c);
            else if (9 === o) {
                i.t = n, i.u = c;
                var b, s = i.s;
                s && (s.A.s = n, (b = s.w).length > 0 && vr(n, r, b, 0, u, a, c));
            } else i.t = n, i.u = c;
            if (!(i = t[++e]) || (f = i.r) > a) return e;
        }
        var v = r.$;
        if (4 === v) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return vr(n, d, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var l = r.e, h = n.childNodes, $ = 0; l.length > $; $++){
            u++;
            var p = 1 === v ? l[$] : l[$].b, g = u + (p.b || 0);
            if (!(u > f || f > g || (i = t[e = vr(h[$], p, t, e, u, g, c)]) && (f = i.r) <= a)) return e;
            u = g;
        }
        return e;
    }
    function dr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = lr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function lr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Gn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Zn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return dr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, a = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(Gn(u[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var c = t.A;
                return void 0 !== c.r && n.parentNode.removeChild(n), c.s = dr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = Tn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                Sn(t, 2 === u.c ? u.s : Gn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = dr(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var c = u[a], i = c.A, f = 2 === i.c ? i.s : Gn(i.z, r.u);
                        n.insertBefore(f, n.childNodes[c.r]);
                    }
                    return e && Sn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                o(10);
        }
    }
    function hr(n) {
        if (3 === n.nodeType) return En(n.textContent);
        if (1 !== n.nodeType) return En("");
        for(var r = w, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = y(A2(Fn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), c = w, i = n.childNodes;
        for(e = i.length; e--;)c = y(hr(i[e]), c);
        return A3(xn, a, r, c);
    }
    var $r = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, a) {
            var c = A2(G, n, r ? r.flags : void 0);
            gt(c) || o(2);
            var i = {}, f = t(c.a), b = f.a, s = a(d, b), v = function(n, r) {
                var t;
                for(var e in gn){
                    var u = gn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = wn(u, r);
                }
                return t;
            }(i, d);
            function d(n, r) {
                var t = A2(e, n, b);
                s(b = t.a, r), Ln(i, t.b, u(b));
            }
            return Ln(i, f.b, u(b)), v ? {
                ports: v
            } : {};
        }(r, e, n.d9, n.eX, n.eR, function(r, t) {
            var e = n.cb && n.cb(r), u = n.eZ, a = Tn.title, c = Tn.body, i = hr(c);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (pr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && pr(e), t = 2);
                };
            }(t, function(n) {
                Nn = e;
                var t = u(n), f = xn("body")(w)(t.dL), o = function(n, r) {
                    var t = [];
                    return er(n, r, t, 0), t;
                }(i, f);
                c = function(n, r, t, e) {
                    return 0 === t.length ? n : (sr(n, r, t, e), dr(n, t));
                }(c, i, o, r), i = f, Nn = 0, a !== t.eU && (Tn.title = a = t.eU);
            });
        });
    }), pr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var gr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, mr = "undefined" != typeof document ? document : gr, wr = "undefined" != typeof window ? window : gr, yr = F3(function(n, r, t) {
        return sn(cn(function() {
            function e(n) {
                bn(t(n));
            }
            return n.addEventListener(r, e, Jn && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), Ar = F2(function(n, r) {
        var t = Z(n, r);
        return gt(t) ? Dr(t.a) : Ir;
    }), _r = F2(function(n, r) {
        return cn(function() {
            var t = setInterval(function() {
                bn(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), kr = A, Nr = i, jr = F3(function(n, r, t) {
        var e = t.c, u = t.d, a = F2(function(r, t) {
            return A3(Nr, r.$ ? n : a, t, r.a);
        });
        return A3(Nr, a, A3(Nr, n, r, u), e);
    }), Or = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(Or, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), Lr = function(n) {
        return A3(Or, F3(function(n, r, t) {
            return A2(kr, h(n, r), t);
        }), w, n);
    }, Cr = function(n) {
        return A3(Or, F3(function(n, r, t) {
            return A2(kr, n, t);
        }), w, n);
    }, Rr = 1, Tr = 2, Sr = 0, Er = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Mr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ur = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Br = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Dr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ir = {
        $: 1
    }, Fr = g, Qr = D, Vr = F2(function(n, r) {
        return A2(B, n, k(r));
    }), qr = F2(function(n, r) {
        return _(A2(U, n, r));
    }), Pr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Yr = function(n) {
        return A3(Pr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, zr = N, Gr = F3(function(n, r, t) {
        for(;;){
            if (d(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(kr, r, t);
            n = e, r = u, t = a;
        }
    }), Zr = F2(function(n, r) {
        return A3(Gr, n, r, w);
    }), Kr = F2(function(n, r) {
        return A3(zr, n, A2(Zr, 0, Yr(r) - 1), r);
    }), Hr = function(n) {
        return A3(Pr, kr, w, n);
    }, Wr = 32, Xr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), nt = [], rt = O, tt = F2(function(n, r) {
        return R(r) / R(n);
    }), et = rt(A2(tt, 2, Wr)), ut = A4(Xr, 0, et, nt, nt), at = t, ct = function(n) {
        return {
            $: 1,
            a: n
        };
    }, it = L, ft = function(n) {
        return n.length;
    }, ot = F2(function(n, r) {
        return d(n, r) > 0 ? n : r;
    }), bt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, st = e, vt = F2(function(n, r) {
        for(;;){
            var t = A2(st, Wr, n), e = t.b, u = A2(kr, bt(t.a), r);
            if (!e.b) return Hr(u);
            n = e, r = u;
        }
    }), dt = function(n) {
        return n.a;
    }, lt = F2(function(n, r) {
        for(;;){
            var t = rt(r / Wr);
            if (1 === t) return A2(st, Wr, n).a;
            n = A2(vt, n, w), r = t;
        }
    }), ht = F2(function(n, r) {
        if (r.l) {
            var t = r.l * Wr, e = it(A2(tt, Wr, t - 1)), u = n ? Hr(r.p) : r.p, a = A2(lt, u, r.l);
            return A4(Xr, ft(r.o) + t, A2(ot, 5, e * et), a, r.o);
        }
        return A4(Xr, ft(r.o), et, nt, r.o);
    }), $t = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(ht, !1, {
                p: e,
                l: t / Wr | 0,
                o: u
            });
            var a = ct(A3(at, Wr, r, n));
            r -= Wr, e = A2(kr, a, e);
        }
    }), pt = F2(function(n, r) {
        if (n > 0) {
            var t = n % Wr;
            return A5($t, r, n - t - Wr, n, w, A3(at, t, n - t, r));
        }
        return ut;
    }), gt = function(n) {
        return !n.$;
    }, mt = P, wt = Y, yt = z, At = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _t = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, kt = function(n) {
        return n;
    }, Nt = function(n) {
        return n.length;
    }, jt = function(n) {
        return "" === n;
    }, Ot = an, Lt = Ot(0), Ct = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var c = a.a, i = a.b;
                if (i.b) {
                    var f = i.a, o = i.b;
                    if (o.b) {
                        var b = o.b;
                        return A2(n, u, A2(n, c, A2(n, f, A2(n, o.a, t > 500 ? A3(Pr, n, r, Hr(b)) : A4(Ct, n, r, t + 1, b)))));
                    }
                    return A2(n, u, A2(n, c, A2(n, f, r)));
                }
                return A2(n, u, A2(n, c, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Rt = F3(function(n, r, t) {
        return A4(Ct, n, r, 0, t);
    }), Tt = F2(function(n, r) {
        return A3(Rt, F2(function(r, t) {
            return A2(kr, n(r), t);
        }), w, r);
    }), St = fn, Et = F2(function(n, r) {
        return A2(St, function(r) {
            return Ot(n(r));
        }, r);
    }), Jt = F3(function(n, r, t) {
        return A2(St, function(r) {
            return A2(St, function(t) {
                return Ot(A2(n, r, t));
            }, t);
        }, r);
    }), Mt = function(n) {
        return A3(Rt, Jt(kr), Ot(w), n);
    }, xt = yn, Ut = F2(function(n, r) {
        var t = r;
        return sn(A2(St, xt(n), t));
    });
    gn.Task = mn(Lt, F3(function(n, r) {
        return A2(Et, function() {
            return 0;
        }, Mt(A2(Tt, Ut(n), r)));
    }), F3(function() {
        return Ot(0);
    }), F2(function(n, r) {
        return A2(Et, n, r);
    })), _n("Task");
    var Bt, Dt, It, Ft, Qt = $r, Vt = V, qt = {
        dR: "\u2588",
        eg: ".",
        eV: "/"
    }, Pt = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Yt = {
        D: ut,
        R: 0,
        M: 0
    }, zt = function(n) {
        return 0 >= n;
    }, Gt = F2(function(n, r) {
        return A2(pt, n, function() {
            return r;
        });
    }), Zt = F3(function(n, r, t) {
        return zt(n) || zt(r) ? Yt : {
            D: A2(Gt, n * r, t),
            R: r,
            M: n
        };
    }), Kt = A3(Pt, 8, 8, A3(Zt, 8, 8, 2)), Ht = function(n) {
        return n.R;
    }, Wt = F2(function(n, r) {
        return r.$ ? Ir : Dr(n(r.a));
    }), Xt = F2(function(n, r) {
        return r.$ ? Ir : n(r.a);
    }), ne = F2(function(n, r) {
        for(;;){
            if (!n.b) return Dr(Hr(r));
            var t = n.a;
            if (t.$) return Ir;
            n = n.b, r = A2(kr, t.a, r);
        }
    }), re = F3(function(n, r, t) {
        return n(r(t));
    }), te = F3(function(n, r, t) {
        return r(n(t));
    }), ee = F2(function(n, r) {
        return A3(Rt, F2(function(r, t) {
            return n(r) ? A2(kr, r, t) : t;
        }), w, r);
    }), ue = F3(function(n, r, t) {
        for(;;){
            var e = A2(st, Wr, n), u = e.a, a = e.b;
            if (0 > d(ft(u), Wr)) return A2(ht, !0, {
                p: r,
                l: t,
                o: u
            });
            n = a, r = A2(kr, ct(u), r), t += 1;
        }
    }), ae = function(n) {
        return n.b ? A3(ue, n, w, 0) : ut;
    }, ce = F2(function(n, r) {
        if (zt(n)) return Ir;
        var t = Yr(r), e = t / n | 0;
        return t % n ? Ir : Dr({
            D: ae(r),
            R: e,
            M: n
        });
    }), ie = function(n) {
        return !n;
    }, fe = S, oe = F3(function(n, r, t) {
        return n > 0 ? A3(oe, n >> 1, m(r, r), 1 & n ? m(t, r) : t) : t;
    }), be = F2(function(n, r) {
        return A3(oe, n, r, "");
    }), se = F3(function(n, r, t) {
        return m(t, A2(be, n - Nt(t), function(n) {
            return A2(fe, n, "");
        }(r)));
    }), ve = v, de = J(function(n) {
        return " " !== n;
    }), le = x, he = function(n) {
        return A3(le, kr, w, n);
    }, $e = F2(function(n, r) {
        var t, e = A2(ee, A2(re, ie, jt), A2(Tt, de, function(n) {
            return _(n.split(/\r\n|\r|\n/g));
        }(r))), u = A3(Pr, ot, 0, A2(Tt, Nt, e)), a = A2(Tt, A2(se, u, "."), e);
        return A2(Xt, ce(u), (t = A3(Rt, Fr, w, A2(Tt, A2(te, he, Tt(n)), a)), A2(ne, t, w)));
    }), pe = function(n) {
        return n.M;
    }, ge = F2(function(n, r) {
        return A2(Wt, function(n) {
            return A3(Pt, pe(n), Ht(n), n);
        }, A2($e, function(r) {
            return b(r, n.dR) ? Dr(0) : b(r, n.eg) ? Dr(1) : b(r, n.eV) ? Dr(2) : Ir;
        }, r));
    }), me = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), we = A2(me, Kt, A2(ge, qt, "\n\u2588 . . . . . . \u2588\n. \u2588 . . . . \u2588 .\n. . \u2588 . . \u2588 . .\n. . . \u2588 \u2588 . . .\n. . . \u2588 \u2588 . . .\n. . \u2588 . . \u2588 . .\n. \u2588 . . . . \u2588 .\n\u2588 . . . . . . \u2588\n")), ye = function(n) {
        return A2(me, we, A2(ge, qt, n));
    }, Ae = ye("\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . \u2588 . \u2588 . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    / \u2588 / / \u2588 \u2588 / /\n    \u2588 \u2588 / / / / \u2588 /\n    / / / / / / / /\n    "), _e = F4(function(n, r, t, e) {
        return n >= 0 && r >= 0 && 0 > d(n, t) && 0 > d(r, e);
    }), ke = F3(function(n, r, t) {
        return r + n * t;
    }), Ne = 4294967295 >>> 32 - et, je = u, Oe = a, Le = F4(function(n, r, t, e) {
        var u = Ne & r >>> n, a = A2(je, u, e);
        return A3(Oe, u, a.$ ? ct(A3(Oe, Ne & r, t, a.a)) : bt(A4(Le, n - et, r, t, a.a)), e);
    }), Ce = function(n) {
        return n >>> 5 << 5;
    }, Re = F3(function(n, r, t) {
        var e = t.a, u = t.b, a = t.c, c = t.d;
        return 0 > n || d(n, e) > -1 ? t : d(n, Ce(e)) > -1 ? A4(Xr, e, u, a, A3(Oe, Ne & n, r, c)) : A4(Xr, e, u, A4(Le, u, n, r, a), c);
    }), Te = F4(function(n, r, t, e) {
        var u = e, a = u.M, c = u.D;
        return A4(_e, n, r, a, u.R) ? p(u, {
            D: A3(Re, A3(ke, a, n, r), t, c)
        }) : e;
    }), Se = F4(function(n, r, t, e) {
        var u = e.a, a = e.b, c = e.c;
        return 0 > d(n, u) && 0 > d(r, a) && n >= 0 && r >= 0 ? A3(Pt, u, a, A4(Te, n, r, t, c)) : e;
    }), Ee = F3(function(n, r, t) {
        for(;;){
            var e = A2(je, Ne & r >>> n, t);
            if (e.$) return A2(je, Ne & r, e.a);
            n -= et, t = e.a;
        }
    }), Je = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, a = r.d;
        return 0 > n || d(n, t) > -1 ? Ir : d(n, Ce(t)) > -1 ? Dr(A2(je, Ne & n, a)) : Dr(A3(Ee, e, n, u));
    }), Me = F3(function(n, r, t) {
        var e = t.M, u = t.D;
        return A4(_e, n, r, e, t.R) ? A2(Je, A3(ke, e, n, r), u) : Ir;
    }), xe = F3(function(n, r, t) {
        return A3(Me, n, r, t.c);
    }), Ue = F3(function(n, r, t) {
        return A3(Pt, n, r, A3(Zt, n, r, t));
    }), Be = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A3(F3(function(u, a, c) {
            for(;;){
                var i = d(u, t - 1) > -1 ? 0 : u + 1, f = i ? a : a + 1, o = A2(n, u, a), b = A4(Se, o.a, o.b, A2(me, 2, A3(xe, u, a, r)), c);
                if (d(f, e) > -1) return b;
                u = i, a = f, c = b;
            }
        }), 0, 0, A3(Ue, t, e, 2));
    }), De = function(n) {
        var r = n.a;
        return A2(Be, F2(function(n, t) {
            return h(r - n - 1, t);
        }), n);
    }, Ie = De(Ae), Fe = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(Fe, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), Qe = F2(function(n, r) {
        return A3(Fe, F3(function(r, t, e) {
            return e.$ ? A2(n, r, t) ? Dr(h(r, t)) : Ir : e;
        }), Ir, r);
    }), Ve = ye("\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . \u2588 . \u2588 . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    / \u2588 / / / \u2588 / /\n    / \u2588 / / / \u2588 / /\n    / \u2588 / / / \u2588 / /\n    "), qe = De(Ve), Pe = ye("\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . \u2588 . \u2588 . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    / / \u2588 / \u2588 / / /\n    / / \u2588 \u2588 / / / /\n    / / / / / / / /\n    "), Ye = De(Pe), ze = ye("\n    / / / / / / / /\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . \u2588 . \u2588 . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    / \u2588 / / / \u2588 / /\n    / \u2588 / / / \u2588 / /\n    "), Ge = De(ze), Ze = ye("\n    . . . . . . . .\n    . . . . . . . .\n    . . . . . . . .\n    . . . . . . . .\n    . . . . . . . .\n    . . . . . . . .\n    . . . . . . . .\n    . . . . . . . .\n    "), Ke = ye("\n    \u2588 . . . . . . \u2588\n    . \u2588 . . . . \u2588 .\n    . . \u2588 . . \u2588 . .\n    . . . \u2588 \u2588 . . .\n    . . . \u2588 \u2588 . . .\n    . . \u2588 . . \u2588 . .\n    . \u2588 . . . . \u2588 .\n    \u2588 . . . . . . \u2588\n    "), He = {
        $: -2
    }, We = He, Xe = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), nu = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Xe, n, r, t, e, u);
            var a = e.d;
            return c = e.e, A5(Xe, 0, e.b, e.c, A5(Xe, 1, a.b, a.c, a.d, a.e), A5(Xe, 1, r, t, c, u));
        }
        var c, i = u.b, f = u.c, o = u.d, b = u.e;
        return -1 !== e.$ || e.a ? A5(Xe, n, i, f, A5(Xe, 0, r, t, e, o), b) : A5(Xe, 0, r, t, A5(Xe, 1, e.b, e.c, e.d, c = e.e), A5(Xe, 1, i, f, o, b));
    }), ru = l, tu = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Xe, 0, n, r, He, He);
        var e = t.a, u = t.b, a = t.c, c = t.d, i = t.e;
        switch(A2(ru, n, u)){
            case 0:
                return A5(nu, e, u, a, A3(tu, n, r, c), i);
            case 1:
                return A5(Xe, e, u, r, c, i);
            default:
                return A5(nu, e, u, a, c, A3(tu, n, r, i));
        }
    }), eu = F3(function(n, r, t) {
        var e = A3(tu, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Xe, 1, e.b, e.c, e.d, e.e);
    }), uu = function(n) {
        return A3(Pr, F2(function(n, r) {
            return A3(eu, n.a, n.b, r);
        }), We, n);
    }, au = F2(function(n, r) {
        return h(n, r);
    }), cu = ye("\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    "), iu = ye("\n    . \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    "), fu = (Dt = (Bt = iu).b, A2(Be, F2(function(n, r) {
        return h(r, Dt - n - 1);
    }), Bt)), ou = ye("\n    \u2588 \u2588 . \u2588 \u2588 \u2588 . \u2588\n    \u2588 \u2588 . \u2588 \u2588 \u2588 . \u2588\n    \u2588 \u2588 . \u2588 \u2588 \u2588 . \u2588\n    . . . . . . . .\n    . \u2588 \u2588 \u2588 . \u2588 \u2588 \u2588\n    . \u2588 \u2588 \u2588 . \u2588 \u2588 \u2588\n    . \u2588 \u2588 \u2588 . \u2588 \u2588 \u2588\n    . . . . . . . .\n    "), bu = ye("\n    . . . . . . . .\n    . . . . . . . .\n    . . \u2588 \u2588 \u2588 \u2588 . .\n    . \u2588 . . . . \u2588 .\n    \u2588 . . . . \u2588 . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . \u2588 . . . \u2588\n    . \u2588 . . . . \u2588 .\n    "), su = ye("\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 . \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 . \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 . . . \u2588 \u2588\n    \u2588 . \u2588 \u2588 . \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    "), vu = ye("\n    \u2588 \u2588 . . . . \u2588 \u2588\n    . \u2588 . . . . \u2588 .\n    \u2588 \u2588 . . \u2588 \u2588 \u2588 \u2588\n    . \u2588 . . \u2588 \u2588 \u2588 .\n    \u2588 \u2588 . . . . \u2588 \u2588\n    . \u2588 . . . . \u2588 .\n    \u2588 \u2588 . . . . \u2588 \u2588\n    . \u2588 . . . . \u2588 .\n    "), du = ye("\n    . . . . . . . .\n    . . . . . . . .\n    . . . . . . . .\n    . \u2588 . \u2588 \u2588 . \u2588 .\n    \u2588 . \u2588 \u2588 \u2588 \u2588 . \u2588\n    . \u2588 . . . . \u2588 .\n    \u2588 \u2588 . . . . \u2588 \u2588\n    . \u2588 . . . . \u2588 .\n    "), lu = ye("\n    . \u2588 \u2588 . . \u2588 \u2588 .\n    \u2588 . . \u2588 \u2588 . . \u2588\n    . . . . \u2588 . . \u2588\n    \u2588 . . . . . . .\n    . . . \u2588 . . . \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 . \u2588 \u2588 \u2588 . \u2588 \u2588\n    "), hu = ye("\n    . \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 .\n    \u2588 . . . . . . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . . . . . . \u2588\n    . \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 .\n    "), $u = ye("\n    \u2588 . . . . . . \u2588\n    . \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    "), pu = function(n) {
        var r = n.b;
        return A2(Be, F2(function(n, t) {
            return h(n, r - t - 1);
        }), n);
    }($u), gu = ye("\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    . \u2588 . . . . \u2588 .\n    "), mu = function(n) {
        var r = n.a;
        return A2(Be, F2(function(n, t) {
            return h(r - t - 1, n);
        }), n);
    }, wu = ye("\n    . \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 .\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    "), yu = mu(wu), Au = ye("\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    \u2588 . . . . . . \u2588\n    \u2588 . \u2588 \u2588 \u2588 \u2588 . \u2588\n    \u2588 . \u2588 \u2588 \u2588 \u2588 . \u2588\n    \u2588 . \u2588 \u2588 . \u2588 . \u2588\n    \u2588 . \u2588 \u2588 . \u2588 . \u2588\n    \u2588 . . . . \u2588 . \u2588\n    \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588 \u2588\n    "), _u = mu(iu), ku = uu(A2(Kr, au, _([
        Ke,
        Ze,
        cu,
        su,
        lu,
        ou,
        Au,
        hu,
        iu,
        _u,
        fu,
        wu,
        yu,
        gu,
        $u,
        pu,
        bu,
        du,
        vu,
        Ae,
        Ie,
        Pe,
        Ye,
        ze,
        Ge,
        Ve,
        qe
    ]))), Nu = function(n) {
        return A2(me, 0, A2(Wt, dt, A2(Qe, F2(function(r, t) {
            return b(t, n);
        }), ku)));
    }, ju = Nu(Ie), Ou = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lu = Ou(ju), Cu = Nu(Ae), Ru = Ou(Cu), Tu = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Su = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Eu = F2(function(n, r) {
        return A2(Su, r.a, n);
    }), Ju = F2(function(n, r) {
        return A2(Tu, 0, A2(Eu, r, A2(Su, n, w)));
    }), Mu = Nu(Ye), xu = Nu(Ge), Uu = C, Bu = function(n) {
        return Uu(60 * n / 60);
    }, Du = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Iu = F2(function(n, r) {
        return A2(Du, n, r);
    }), Fu = A2(Ju, A2(Iu, Bu(4), ju), _([
        A2(Iu, Bu(4), xu),
        A2(Iu, Bu(4), Mu),
        A2(Iu, Bu(4), xu)
    ])), Qu = Nu(Pe), Vu = Nu(ze), qu = A2(Ju, A2(Iu, Bu(4), Cu), _([
        A2(Iu, Bu(4), Vu),
        A2(Iu, Bu(4), Qu),
        A2(Iu, Bu(4), Vu)
    ])), Pu = Nu(qe), Yu = A2(Ju, A2(Iu, Bu(14), xu), _([
        A2(Iu, Bu(14), Pu)
    ])), zu = Nu(Ve), Gu = {
        eb: Lu,
        ec: Ru,
        eJ: Fu,
        eK: qu,
        eO: Yu,
        eP: A2(Ju, A2(Iu, Bu(14), Vu), _([
            A2(Iu, Bu(14), zu)
        ]))
    }, Zu = w, Ku = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hu = F2(function(n, r) {
        return {
            bY: n.aL + Uu((8 - n.aL - n.dg) / 2),
            bZ: 8 - n.cx,
            aG: 1,
            R: 8,
            aQ: Ku(0),
            b9: n,
            bg: 0,
            ap: 0,
            aS: 0,
            bi: r,
            M: 8,
            N: 0,
            O: 0
        };
    }), Wu = F2(function(n, r) {
        return 0 > d(n, r) ? n : r;
    }), Xu = function(n) {
        return A2(Wu, n.e_ / 176 | 0, n.d3 / 176 | 0);
    }, na = kn(w), ra = F3(function(n, r, t) {
        return p(t, {
            ap: n,
            aS: r,
            N: n,
            O: r
        });
    }), ta = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ea = {
        cC: A4(ta, 0, 0, 0, 1),
        cY: A4(ta, 1, 1, 1, 1)
    }, ua = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), aa = F2(function(n, r) {
        return A3(ua, n, r, A3(Zt, n, r, !1));
    }), ca = Nu(Ze), ia = F2(function(n, r) {
        return {
            R: r,
            cj: A3(Zt, n, r, ca),
            M: n
        };
    }), fa = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Ir;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(ru, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Dr(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), oa = F2(function(n, r) {
        return A2(Wt, function(n) {
            return {
                R: Ht(n),
                cj: n,
                M: pe(n)
            };
        }, A2($e, function(r) {
            return A2(fa, r, n);
        }, r));
    }), ba = A2(me, A2(ia, 0, 0), A2(oa, uu(_([
        h("#", 0)
    ])), "\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    # # # # # # # # # # # # # # # # # # # # # #\n    ")), sa = {
        bt: A2(aa, 22, 22),
        bu: ea,
        a_: ba
    }, va = function(n) {
        return n.R;
    }, da = function(n) {
        return va(n.a_);
    }, la = function(n) {
        return n.M;
    }, ha = function(n) {
        return la(n.a_);
    }, $a = function(n) {
        return A2(Wt, function(r) {
            return {
                aT: 8 * da(r),
                dk: da(r),
                aU: 8 * ha(r),
                dl: ha(r),
                ar: n,
                ch: 8,
                ci: 8
            };
        }, A3(Me, 0, 0, n));
    }, pa = F4(function(n, r, t, e) {
        var u = $(n, r, t), a = u.a, c = u.b, i = u.c, f = i > .5 ? i + c - i * c : i * (c + 1), o = 2 * i - f, b = function(n) {
            var r = 0 > n ? n + 1 : n > 1 ? n - 1 : n;
            return 1 > 6 * r ? o + (f - o) * r * 6 : 1 > 2 * r ? f : 2 > 3 * r ? o + (f - o) * (2 / 3 - r) * 6 : o;
        }, s = b(a - 1 / 3), v = b(a), d = b(a + 1 / 3);
        return A4(ta, d, v, s, e);
    }), ga = F3(function(n, r, t) {
        return A4(pa, n, r, t, 1);
    }), ma = function(n) {
        return n / 100;
    }, wa = F3(function(n, r, t) {
        return A3(ga, n / 360, ma(r), ma(t));
    }), ya = A3(wa, 300, 14, 36), Aa = F3(function(n, r, t) {
        return 0 > d(t, n) ? n : d(t, r) > 0 ? r : t;
    }), _a = F3(function(n, r, t) {
        var e = A3(Aa, 0, n, t), u = A3(Aa, -1, 1, r);
        return e + (u > 0 ? n - e : e) * u;
    }), ka = T, Na = F2(function(n, r) {
        var t = function(n) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = A2(Wu, r, A2(Wu, t, e)), c = A2(ot, r, A2(ot, t, e)), i = (a + c) / 2, f = b(a, c) ? 0 : .5 > i ? (c - a) / (c + a) : (c - a) / (2 - c - a), o = (b(c, r) ? (t - e) / (c - a) : b(c, t) ? 2 + (e - r) / (c - a) : 4 + (r - t) / (c - a)) * (1 / 6);
            return {
                dB: u,
                cQ: ka(o) ? 0 : 0 > o ? o + 1 : o,
                cZ: i,
                di: f
            };
        }(r), e = n.eh, u = n.dC;
        return A4(pa, t.cQ, A3(_a, 1, n.eL, t.di), A3(_a, 1, e, t.cZ), A3(_a, 1, u, t.dB));
    }), ja = F2(function(n, r) {
        return A2(Na, {
            dC: 0,
            eh: n,
            eL: 0
        }, r);
    }), Oa = function(n) {
        return {
            cC: n,
            cY: A2(ja, .7, n)
        };
    }, La = Oa(ya), Ca = Nu(ou), Ra = Nu(bu), Ta = Nu(su), Sa = Nu(vu), Ea = Nu(du), Ja = Nu(lu), Ma = Nu(pu), xa = Nu(gu), Ua = Nu($u), Ba = Nu(Au), Da = uu(_([
        h(".", ca),
        h("\u2593", Ta),
        h("\u2592", Ca),
        h("\u2580", Ja),
        h("\u259A", Ba),
        h("\u2565", Ua),
        h("\u2551", xa),
        h("\u2568", Ma),
        h("\u25CD", Ra),
        h("\u25B3", Ea),
        h("\u25AF", Sa)
    ])), Ia = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Fa = F2(function(n, r) {
        return A2(Ia, function(r) {
            return b(r, n);
        }, r);
    }), Qa = F2(function(n, r) {
        return A2(Wt, function(n) {
            return A3(ua, pe(n), Ht(n), n);
        }, A2($e, function(r) {
            return Dr(A2(Fa, r, n));
        }, r));
    }), Va = function(n) {
        return !A2(Fa, n, _([
            ".",
            "\u2565",
            "\u2551",
            "\u2568",
            "\u25CD",
            "\u25B3",
            "\u25AF"
        ]));
    }, qa = F3(function(n, r, t) {
        var e = la(r), u = va(r);
        return 22 === e && 22 === u && 22 === t.a && 22 === t.b ? Dr({
            bt: t,
            bu: n,
            a_: r
        }) : Ir;
    }), Pa = F2(function(n, r) {
        var t = A2(me, A2(ia, 0, 0), A2(oa, Da, r)), e = A2(me, A2(aa, 22, 22), A2(Qa, A2(ee, Va, Cr(Da)), r));
        return A2(me, sa, A3(qa, n, t, e));
    }), Ya = A2(Pa, La, "\n    . . . \u2592 \u2592 \u2592 \u2592 \u2593 . . . . . . . . . . . . . .\n    . . . \u2593 \u2593 \u2565 . . . . . . . . . . . . . . . .\n    \u2593 \u2593 \u2593 \u2593 . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2593 \u2593 . . . . . . . . . . \u25B3 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2593 \u2593 . . . . . . . . . . \u25AF \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2593 \u2593 . . . . \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592\n    . . . \u2593 . \u2592 . . . . . . . . . . . . . . . .\n    . . . \u2593 . . . . . . . . . . . . . . . . . .\n    \u2593 \u2593 \u2592 . . . . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2565 . . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2551 . . . \u25CD \u25CD . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 . . . . \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 . . . . . . \u2565 . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 . . . . . . \u2551 . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2592 \u2592 \u2592 \u2592 \u2593 \u2593 \u2568 \u25CD \u25CD . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 . . . . \u2593 \u2592 \u2592 \u2592 \u2592 . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u25B3 . . . . \u2565 . . . \u2565 . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u25AF . . . . \u2551 . . . \u2551 . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2592 \u2592 \u2592 \u2592 . \u2568 . . . \u2568 . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2593 \u2593 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    "), za = A2(Pa, La, "\n    . . \u2593 \u2592 \u2592 \u2592 \u2592 . . . . . . . . . . . . . . .\n    . . . . . \u2593 \u2593 . . . . . . . . . . . . . . .\n    . . . . . \u2593 \u2592 \u2592 \u2592 \u2592 . . . . \u2565 . . . . . . .\n    . . . . . . . . \u2593 \u2593 . . . . \u2551 . . . . . . .\n    . . . . \u2565 . . . \u2593 \u2592 \u2592 \u2592 \u2592 . \u2551 . . . . . . .\n    . \u25CD \u25CD . \u2551 . . . . . . \u2593 \u2593 . \u2568 . . . . . . .\n    \u2592 \u2592 \u2592 \u2592 \u2551 . . . . . . \u2593 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592\n    . . \u2593 \u2593 \u2568 . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . \u2593 \u2592 \u2592 \u2592 \u2592 . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . \u2593 \u2593 . \u25CD \u25CD . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . \u2593 \u2592 \u2592 \u2592 \u2592 . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . . . . \u2565 \u2593 \u2593 . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . . . . \u2551 \u2593 \u2593 . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . . . . . . . . \u2592 \u2592 \u2592 \u2592 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . . . . . \u25CD \u25CD . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . . . . . \u2592 \u2592 \u2592 \u2592 \u2593 . . . . . . . .\n    . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 . . . . . . . .\n    . . . . . . \u2592 \u2592 \u2592 \u2592 \u2593 . . . . . . . . . . .\n    . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 . . . . . . . . . . .\n    . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 . . . . . . . . . . .\n    . . . \u2592 \u2592 \u2592 \u2592 \u2593 . . . . . . . . . . . . . .\n    "), Ga = Oa(A3(wa, 21, 93, 48)), Za = A2(Pa, Ga, "\n    . . . . . . . . . . . \u2580 \u2580 \u2580 \u2580 . . . . . . .\n    . . . . . . . \u2580 \u2580 . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . \u2580 \u2580 . . \u2580 \u2580 . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . \u2580 . . . \u2580 \u2580 . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . \u2580 \u2580 \u2580 \u2580 \u2580 . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . \u2580 \u2580 \u2580 \u2580 . . \u2580 \u2580 \u2580 \u2580 . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . \u2580 \u2580 . . \u2580 \u2580 \u2580 \u2580 . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . \u2580 \u2580 . . \u2580 \u2580 . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . \u2593 \u2593 . . . . . . . . . . . . . . . . . .\n    . . \u2593 \u2592 \u2592 \u2592 \u2592 . . . . . . . . . . . . . . .\n    "), Ka = A2(Pa, Ga, "\n    \u2593 . . \u2593 . . . . . \u259A \u259A \u259A \u259A . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 \u2580 . \u2593 . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . \u25CD \u25CD . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . \u2593 \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    . . \u2580 \u2593 . . . \u2593 \u2593 . . . . . . . . . . . . .\n    . . . \u2593 . . . \u2593 \u2593 . . . . . . . . . . . . .\n    . . . \u2593 . \u2580 \u2580 \u2593 \u2593 . . . . . . . . . . . . .\n    \u2593 \u2593 \u2593 \u2593 . . . \u2593 \u2593 . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2593 \u2593 . . . \u2593 \u2593 . . . \u2580 \u2580 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2593 \u2593 \u2580 \u2580 . \u2593 \u2593 . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 \u2593 \u2593 \u2593 . . . \u2593 \u2593 . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    . . . . . . \u2580 . . . \u2580 \u2580 . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . \u2580 \u2580 \u2580 \u2580 \u2580 . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . \u2580 \u2580 \u2580 \u2580 . . \u2580 \u2580 \u2580 \u2580 . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . \u2580 \u2580 \u2580 \u2580 . . . . . . .\n    "), Ha = Oa(A3(wa, 249, 46, 45)), Wa = A2(Pa, Ha, "\n    \u2593 . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 . . . . \u2592 \u2592 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . . . \u2593 \u2593 \u2593 . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2592 \u2592 \u2592 \u2593 \u2593 . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 \u2580 . \u2593 . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . \u259A \u259A \u259A \u259A . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u259A \u259A \u259A \u259A\n    \u2593 . \u2580 \u2593 . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . \u259A \u259A \u259A \u259A . \u2593 \u2593 \u2593 \u2593 \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 \u2580 . \u2593 . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 \u259A \u259A \u259A \u259A . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . \u2580 \u2593 . . . . . . \u25CD \u25CD . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . \u259A \u259A \u259A \u259A . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 \u2580 . \u2593 . . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 \u259A \u259A \u259A \u259A . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . . \u2593 . . . . . . . . . . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    \u2593 . \u2580 \u2593 . . . . . \u259A \u259A \u259A \u259A . . \u259A \u259A \u259A \u259A \u259A \u259A \u259A\n    "), Xa = A2(Pa, Ha, "\n    . . . . . . . . . . . . . \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592\n    . . . . . . . . . . . . . \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592\n    . . . . . . . . . . . . . \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592\n    . . \u2593 \u2580 \u2580 \u2593 . . \u2593 . . \u2593 . \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592\n    . . \u2593 . . \u2593 . . \u2593 . . \u2593 . . . . . . . . . .\n    . . \u2593 . . \u2593 . . \u2593 . . \u2593 . . . . . . . . . .\n    \u2580 \u2580 \u2593 . . \u2593 . . \u2593 . . \u2593 . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 . . . . . . . . . . . . \u2592 \u2592\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . \u2593 . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . \u2593 . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    . . . . . . . . . . . . . . . . . . . . . .\n    \u2593 . . . . . \u2580 \u2580 \u2580 \u2580 . . \u2580 \u2580 \u2580 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 . . . . . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 . . . . . . . . . . . . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 . . . . . . . . . \u25B3 \u2593 . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 . . . . . . \u25CD \u25CD . \u25AF \u2593 . . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    \u2593 . . . . . \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 \u2592 . . \u2593 \u2593 \u2593 \u2593 \u2593 \u2593 \u2593\n    "), nc = A2(me, {
        aT: 8 * da(It = sa),
        dk: da(It),
        aU: 8 * ha(It),
        dl: ha(It),
        ar: A3(Zt, 1, 1, It),
        ch: 8,
        ci: 8
    }, A2(Xt, $a, A2(ce, 1, _([
        Xa,
        Wa,
        Ka,
        Za,
        za,
        Ya
    ])))), rc = {
        cx: 0,
        aL: 0,
        dg: 0,
        bO: 0
    }, tc = F, ec = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ac = {
        $: 0
    }, cc = F2(function(n, r) {
        return {
            d3: r,
            e_: n
        };
    }), ic = kn, fc = {
        $: 4
    }, oc = A2(wt, function(n) {
        switch(n){
            case "ArrowLeft":
                return Dr(0);
            case "ArrowRight":
                return Dr(1);
            case " ":
                return Dr(2);
            default:
                return Ir;
        }
    }, A2(Vt, "key", Q)), bc = function(n) {
        return A2(wt, function(r) {
            return r.$ ? fc : n(r.a);
        }, oc);
    }, sc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), vc = F2(function(n, r) {
        return {
            da: r,
            ds: n
        };
    }), dc = Ot(A2(vc, We, We)), lc = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(fa, t, r);
        return A3(eu, t, 1 === u.$ ? _([
            e
        ]) : A2(kr, e, u.a), r);
    }), hc = function(n) {
        return cn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(an(0));
        });
    }, $c = F6(function(n, r, t, e, u, a) {
        var c = A3(Fe, F3(function(e, u, a) {
            n: for(;;){
                var c = a.a, i = a.b;
                if (c.b) {
                    var f = c.a, o = f.a, b = f.b, s = c.b;
                    if (0 > d(o, e)) {
                        a = h(s, A3(n, o, b, i));
                        continue n;
                    }
                    return d(o, e) > 0 ? h(c, A3(t, e, u, i)) : h(s, A4(r, o, b, u, i));
                }
                return h(c, A3(t, e, u, i));
            }
        }), h(Lr(e), a), u), i = c.a, f = c.b;
        return A3(Pr, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), f, i);
    }), pc = An, gc = _r, mc = sn, wc = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = mc(A2(gc, e, A2(pc, n, e)));
            return A2(St, function(r) {
                return A3(wc, n, u, A3(eu, e, r, t));
            }, a);
        }
        return Ot(t);
    }), yc = F3(function(n, r, t) {
        var e = t.da, u = F3(function(n, r, t) {
            var e = t.c;
            return $(t.a, t.b, A2(St, function() {
                return e;
            }, hc(r)));
        }), a = A3(Pr, lc, We, r), c = A6($c, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return $(A2(kr, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return $(e.a, A3(eu, n, t, e.b), u);
        }), u, a, e, $(w, We, Ot(0))), i = c.a, f = c.b;
        return A2(St, function(n) {
            return Ot(A2(vc, a, n));
        }, A2(St, function() {
            return A3(wc, n, i, f);
        }, c.c));
    }), Ac = (Ft = kt, cn(function(n) {
        n(an(Ft(Date.now())));
    }));
    gn.Time = mn(dc, yc, F3(function(n, r, t) {
        var e = A2(fa, r, t.ds);
        if (1 === e.$) return Ot(t);
        var u = e.a;
        return A2(St, function() {
            return Ot(t);
        }, A2(St, function(r) {
            return Mt(A2(Tt, function(t) {
                return A2(xt, n, t(r));
            }, u));
        }, Ac));
    }), 0, F2(function(n, r) {
        return A2(sc, r.a, A2(re, n, r.b));
    }));
    var _c = _n("Time"), kc = F2(function(n, r) {
        return _c(A2(sc, n, r));
    }), Nc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), jc = F2(function(n, r) {
        return {
            c7: r,
            dr: n
        };
    }), Oc = Ot(A2(jc, w, We)), Lc = function(n) {
        return h(m(n.a ? "w_" : "d_", n.b), n);
    }, Cc = F2(function(n, r) {
        return {
            cI: r,
            cV: n
        };
    }), Rc = F3(function(n, r, t) {
        return A2(Et, function(n) {
            return h(r, n);
        }, A3(yr, t.a ? wr : mr, t.b, function(t) {
            return A2(pc, n, A2(Cc, r, t));
        }));
    }), Tc = F2(function(n, r) {
        return A3(Fe, eu, r, n);
    }), Sc = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return $(e.a, e.b, A2(kr, A3(Rc, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return $(A2(kr, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return $(e.a, A3(eu, n, r, e.b), u);
        }), c = A2(Tt, Lc, r), i = A6($c, u, a, e, t.c7, uu(c), $(w, We, w)), f = i.b, o = i.c;
        return A2(St, function(n) {
            return Ot(A2(jc, c, A2(Tc, f, uu(n))));
        }, A2(St, function() {
            return Mt(o);
        }, Mt(A2(Tt, hc, i.a))));
    }), Ec = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(kr, e.a, t);
    }), Jc = F2(function(n, r) {
        return A3(Rt, Ec(n), w, r);
    });
    gn["Browser.Events"] = mn(Oc, Sc, F3(function(n, r, t) {
        var e = r.cV, u = r.cI, a = A2(Jc, function(n) {
            var r = n.b.c;
            return b(n.a, e) ? A2(Ar, r, u) : Ir;
        }, t.dr);
        return A2(St, function() {
            return Ot(t);
        }, Mt(A2(Tt, xt(n), a)));
    }), 0, F2(function(n, r) {
        return A3(Nc, r.a, r.b, A2(wt, n, r.c));
    }));
    var Mc, xc, Uc = _n("Browser.Events"), Bc = F3(function(n, r, t) {
        return Uc(A3(Nc, n, r, t));
    }), Dc = A2(Bc, 0, "keydown"), Ic = A2(Bc, 0, "keyup"), Fc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Qc = F2(function(n, r) {
        var t = r, e = t.O, u = t.aQ, a = t.b9, c = n({
            d3: t.R - a.bO - a.cx,
            ap: t.ap + a.aL,
            aS: t.aS + a.bO,
            e_: t.M - a.aL - a.dg,
            N: t.N + a.aL,
            O: e + a.bO
        }), i = c.a - a.aL, f = c.b - a.bO;
        return p(t, {
            aQ: function() {
                if (d(f, e) >= 0) return d(f, e) > 0 ? Ku(1) : u;
                switch(u.$){
                    case 0:
                    case 1:
                        return Fc(u.a);
                    default:
                        return Fc(1);
                }
            }(),
            ap: i,
            aS: f,
            N: i,
            O: f
        });
    }), Vc = F2(function(n, r) {
        return n - r > 0;
    }), qc = j, Pc = F4(function(n, r, t, e) {
        return A2(Vc, n, r) ? -A2(qc, e, n + t) : e - A2(qc, e, n);
    }), Yc = F4(function(n, r, t, e) {
        return !b((n + t) / e | 0, (r + t) / e | 0);
    }), zc = F3(function(n, r, t) {
        var e = n.N, u = n.ap, a = n.e_, c = A4(Yc, n.O, n.aS, n.d3, t), i = A4(Yc, e, u, a, r);
        return !b(i, c) && i;
    }), Gc = function(n) {
        return n.a;
    }, Zc = function(n) {
        return n.b;
    }, Kc = F4(function(n, r, t, e) {
        var u = e.N, a = e.O, c = e.ap, i = e.aS, f = e.e_, o = e.d3, b = function(n) {
            var r = n.N, t = n.O, e = n.e_, u = n.d3, a = n.ap, c = n.aS, i = h(r + e - 1, t), f = h(r, t), o = A2(Vc, r, a), b = A2(Vc, t, c), s = h(r + e - 1, t + u - 1), v = h(r, t + u - 1);
            return o && b ? {
                a7: i,
                a8: v,
                be: s
            } : o && !b ? {
                a7: s,
                a8: f,
                be: i
            } : !o && b ? {
                a7: f,
                a8: s,
                be: v
            } : {
                a7: v,
                a8: i,
                be: f
            };
        }(e), s = b.a7, v = b.a8, d = b.be, l = A2(n, Gc(s), Zc(s)), $ = A2(n, Gc(v), Zc(v)), p = A2(n, Gc(d), Zc(d));
        if (l || $ || p) {
            var g = A4(Pc, a, i, o, t), m = A4(Pc, u, c, f, r);
            return l || $ ? h(l ? u + m : u, $ ? a + g : a) : A3(zc, e, r, t) ? h(u + m, a) : h(u, a + g);
        }
        return h(u, a);
    }), Hc = F5(function(n, r, t, e, u) {
        return A2(e, A3(Kc, t, n, r), u);
    }), Wc = F3(function(n, r, t) {
        return A2(me, !1, A3(Me, n, r, t.c));
    }), Xc = F3(function(n, r, t) {
        return A3(Wc, r / 8 | 0, t / 8 | 0, n.bt);
    }), ni = F5(function(n, r, t, e, u) {
        var a = it(u / t), c = it(e / r), i = pe(n), f = Ht(n);
        return h(A2(qc, i, c), A2(qc, f, a));
    }), ri = F5(function(n, r, t, e, u) {
        var a = A5(ni, n, r, t, e, u);
        return A3(Me, a.a, a.b, n);
    }), ti = F3(function(n, r, t) {
        var e = n.aU, u = n.aT, a = A5(ri, n.ar, e, u, r, t);
        return !a.$ && A3(Xc, a.a, A2(qc, e, r), A2(qc, u, t));
    }), ei = F2(function(n, r) {
        var t = n.ci, e = n.ch, u = ti(n);
        return A5(Hc, t, e, u, Qc, r);
    }), ui = F2(function(n, r) {
        return A2(kr, n, r);
    }), ai = F2(function(n, r) {
        var t = r;
        return A2(ee, ve(n), t);
    }), ci = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ii = F2(function(n, r) {
        for(;;){
            if (!r.b) return Ir;
            var t = r.a, e = r.b;
            if (n(t)) return Dr(t);
            r = e;
        }
    }), fi = function(n) {
        return !n || 1 === n;
    }, oi = F3(function(n, r, t) {
        return b(r, t) ? n : d(r, t) > 0 ? 1 : 0;
    }), bi = F3(function(n, r, t) {
        var e = b(r, t) ? 0 : 1;
        switch(n.$){
            case 0:
                return e;
            case 2:
                return 2;
            default:
                return n.a ? 2 : e;
        }
    }), si = function(n) {
        return Uu(60 * n / 60);
    }, vi = si(1), di = Bu(24), li = si(1), hi = F2(function(n, r) {
        var t = r.bi, e = r.bg, u = r.aG;
        return p(r, {
            bi: function() {
                var r = h(e, u);
                if (1 === r.b) switch(r.a){
                    case 0:
                        return p(t, {
                            eP: n(t.eP)
                        });
                    case 1:
                        return p(t, {
                            eK: n(t.eK)
                        });
                    default:
                        return p(t, {
                            ec: n(t.ec)
                        });
                }
                else switch(r.a){
                    case 0:
                        return p(t, {
                            eO: n(t.eO)
                        });
                    case 1:
                        return p(t, {
                            eJ: n(t.eJ)
                        });
                    default:
                        return p(t, {
                            eb: n(t.eb)
                        });
                }
            }()
        });
    }), $i = si(1), pi = function(n) {
        return n.a;
    }, gi = F3(function(n, r, t) {
        return A3(Pr, n, r, A2(kr, t.a, t.b));
    }), mi = function(n) {
        if (n.$) {
            var r = n.b, t = n.a + 1;
            return d(t, function(n) {
                return A3(gi, F2(function(n, r) {
                    return pi(n) + r;
                }), 0, n);
            }(r)) > -1 ? A2(Tu, 0, r) : A2(Tu, t, r);
        }
        return n;
    }, wi = F2(function(n, r) {
        var t = r, e = t.O, u = t.N, a = t.ap, c = t.aQ, i = t.aG, f = function() {
            var r = function(n) {
                var r = A2(ii, fi, n);
                n: for(; !r.$;)switch(r.a){
                    case 0:
                        return 1;
                    case 1:
                        return 2;
                    default:
                        break n;
                }
                return 0;
            }(n);
            switch(r){
                case 0:
                    return u;
                case 1:
                    return u - $i;
                default:
                    return u + $i;
            }
        }(), o = function() {
            if (function(n) {
                return A2(Fa, 2, n);
            }(n)) switch(c.$){
                case 1:
                    return Ku(1);
                case 0:
                    return c.a ? c : ci(0);
                default:
                    var r = c.a;
                    return 0 > d(r, di) ? ci(r + 1) : Ku(1);
            }
            else switch(c.$){
                case 0:
                    return Ku(0);
                case 2:
                    return Ku(1);
                default:
                    return c;
            }
        }(), b = 2 === o.$ ? e - li : e + vi;
        return A2(hi, mi, p(t, {
            aG: A3(oi, i, f, a),
            aQ: o,
            bg: A3(bi, o, f, a),
            N: f,
            O: b
        }));
    }), yi = F2(function(n, r) {
        var t = h(r, na);
        switch(n.$){
            case 0:
                return h(p(r, {
                    a6: A2(ei, r.bQ, A2(wi, r.al, r.a6))
                }), na);
            case 2:
                return h(p(r, {
                    al: A2(ui, n.a, r.al)
                }), na);
            case 3:
                return h(p(r, {
                    al: A2(ai, n.a, r.al)
                }), na);
            case 1:
                return h(p(r, {
                    bJ: Xu(n.a)
                }), na);
            default:
                return t;
        }
    }), Ai = F2(function(n, r) {
        return A2(Fn, function(n) {
            return Vn.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return qn.test(n) ? "" : n;
        }(r));
    }), _i = F2(function(n, r) {
        return !A2(Ia, A2(re, ie, n), r);
    }), ki = function(n) {
        return !n.b;
    }, Ni = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return ki(n.a.c) ? h(t, e) : h(t, A2(kr, n, e));
            case 1:
                return h(t, A2(_i, function(n) {
                    return ki(n.c);
                }, n.b) ? e : A2(kr, n, e));
            case 2:
                return ki(n.b) ? h(t, e) : h(t, A2(kr, n, e));
            case 3:
                return h(t, A2(kr, n, e));
            case 4:
            case 5:
            case 7:
            case 8:
                return ki(n.a) ? h(t, e) : h(t, A2(kr, n, e));
            case 6:
                var u = n.a;
                return jt(u.dS) ? h(t, e) : h(A3(eu, u.en, u.dS, t), e);
            default:
                return h(t, A2(_i, function(n) {
                    return ki(n.b);
                }, n.a) ? e : A2(kr, n, e));
        }
    }), ji = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Oi = F2(function(n, r) {
        return r.b ? A3(Rt, kr, r, n) : n;
    }), Li = F2(function(n, r) {
        return A2(Oi, A2(Tt, function(n) {
            return ji({
                dS: n.b,
                en: n.a
            });
        }, Lr(n)), r);
    }), Ci = function(n) {
        var r = A3(Rt, Ni, h(We, w), n);
        return A2(Li, r.a, r.b);
    }, Ri = F4(function(n, r, t, e) {
        n: for(;;){
            if (t.b) {
                if (t.b.b) {
                    var u = n, a = r, c = t.b, i = e + (n(t.a) + (r + ""));
                    n = u, r = a, t = c, e = i;
                    continue n;
                }
                return e + (n(t.a) + "");
            }
            return e;
        }
    }), Ti = F3(function(n, r, t) {
        return A4(Ri, n, r, t, "");
    }), Si = function(n) {
        return "(" + n.cJ + A2(me, "", A2(Wt, Fr(": "), n.U)) + ")";
    }, Ei = function(n) {
        var r = F3(function(n, r, t) {
            return n + " " + A2(Vr, " and ", A2(kr, function(n) {
                switch(n){
                    case 0:
                        return "print";
                    case 1:
                        return "screen";
                    default:
                        return "speech";
                }
            }(r), A2(Tt, Si, t)));
        });
        switch(n.$){
            case 0:
                return A3(Ti, Si, " and ", n.a);
            case 1:
                return A3(r, "only", n.a, n.b);
            case 2:
                return A3(r, "not", n.a, n.b);
            default:
                return n.a;
        }
    }, Ji = F2(function(n, r) {
        return '@import "' + n + Ei(r) + '"';
    }), Mi = function(n) {
        var r = n.b;
        return A3(Ti, Ji(n.a), "\n", r);
    }, xi = function(n) {
        return "@namespace " + n.a + '"' + n.b + '"';
    }, Ui = E, Bi = function(n) {
        return "::" + n;
    }, Di = function(n) {
        switch(n.$){
            case 0:
                return "." + n.a;
            case 1:
                return "#" + n.a;
            case 2:
                return ":" + n.a;
            default:
                return "[" + n.a + "]";
        }
    }, Ii = function(n) {
        switch(n.$){
            case 0:
            default:
                return m(n.a, A3(Ti, Di, "", r = n.b));
            case 1:
                var r;
                return ki(r = n.a) ? "*" : A3(Ti, Di, "", r);
        }
    }, Fi = function(n) {
        var r = n.b;
        return function(n) {
            switch(n){
                case 0:
                    return "+";
                case 1:
                    return "~";
                case 2:
                    return ">";
                default:
                    return "";
            }
        }(n.a) + " " + Ii(r);
    }, Qi = function(n) {
        var r = n.b, t = n.c, e = A2(kr, Ii(n.a), A2(Tt, Fi, r)), u = A2(me, "", A2(Wt, Bi, t));
        return A2(Ui, A2(Vr, " ", e), u);
    }, Vi = function(n) {
        var r = n.c;
        return A3(Ti, Qi, ",", A2(kr, n.a, n.b)) + "{" + function(n) {
            return A3(Ti, function(n) {
                return n + ";";
            }, "", n);
        }(r) + "}";
    }, qi = function(n) {
        switch(n.$){
            case 0:
                return Vi(n.a);
            case 1:
                var r = n.b;
                return "@media " + A3(Ti, Ei, ", ", n.a) + "{" + A3(Ti, Vi, "\n", r) + "}";
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            default:
                return "TODO";
            case 6:
                return "@keyframes " + n.a.en + "{" + n.a.dS + "}";
        }
    }, Pi = function(n) {
        return A3(Rt, Oi, w, n);
    }, Yi = F2(function(n, r) {
        return Pi(A2(Tt, n, r));
    }), zi = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Gi = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Zi = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ki = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Hi = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Wi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xi = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), nf = function(n) {
        return {
            $: 7,
            a: n
        };
    }, rf = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), tf = F2(function(n, r) {
        return r.b ? r.b.b ? A2(kr, r.a, A2(tf, n, r.b)) : _([
            n(r.a)
        ]) : r;
    }), ef = F2(function(n, r) {
        return A3(Hi, r.a, r.b, m(r.c, _([
            n
        ])));
    }), uf = F2(function(n, r) {
        if (!r.b) return r;
        if (r.b.b) return A2(kr, r.a, A2(uf, n, r.b));
        switch(r.a.$){
            case 0:
                return _([
                    Wi(A2(ef, n, r.a.a))
                ]);
            case 1:
                var t = r.a, e = t.b;
                return _([
                    A2(rf, t.a, A2(tf, ef(n), e))
                ]);
            default:
                return r;
        }
    }), af = F2(function(n, r) {
        if (r.b.b) {
            var t = r.a, e = r.b, u = (c = r.c, A2(Tt, n, e)), a = n(t);
            return _([
                A3(Hi, t, e, c),
                A3(Hi, a, u, w)
            ]);
        }
        var c, i = r.a;
        return _([
            A3(Hi, i, w, c = r.c),
            A3(Hi, n(i), w, w)
        ]);
    }), cf = F2(function(n, r) {
        return A3(Ki, r.a, r.b, Dr(n));
    }), ff = F2(function(n, r) {
        return A2(af, cf(n), r);
    }), of = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), bf = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), sf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vf = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(bf, r.a, m(r.b, _([
                    n
                ])));
            case 1:
                return sf(m(r.a, _([
                    n
                ])));
            default:
                return A2(of, r.a, m(r.b, _([
                    n
                ])));
        }
    }), df = F2(function(n, r) {
        if (r.b) {
            if (r.b.b) return A2(kr, r.a, A2(df, n, r.b));
            var t = r.a;
            return _([
                h(t.a, A2(vf, n, t.b))
            ]);
        }
        return w;
    }), lf = F2(function(n, r) {
        if (r.b.b) return t = r.c, A3(Ki, r.a, A2(df, n, r.b), t);
        var t = r.c;
        return A3(Ki, A2(vf, n, r.a), w, t);
    }), hf = F2(function(n, r) {
        return A2(af, lf(n), r);
    }), $f = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.a.$) {
                    n = t = n.b;
                    continue n;
                }
                var r = n.a.a, t = n.b;
                return m(A2(kr, r.a, r.b), $f(t));
            }
            return w;
        }
    }, pf = F5(function(n, r, t, e, u) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), gf = F2(function(n, r) {
        n: for(;;){
            if (!r.b) return r;
            if (r.b.b) break n;
            switch(r.a.$){
                case 0:
                    return A2(Tt, Wi, n(b = r.a.a));
                case 1:
                    if (r.a.b.b) {
                        if (r.a.b.b.b) {
                            var t = r.a, e = t.b, u = e.a, a = A2(gf, n, _([
                                A2(rf, t.a, e.b)
                            ]));
                            if (a.b && 1 === a.a.$ && !a.b.b) {
                                var c = a.a;
                                return _([
                                    A2(rf, c.a, A2(kr, u, c.b))
                                ]);
                            }
                            return a;
                        }
                        var i = r.a;
                        return _([
                            A2(rf, i.a, n(b = i.b.a))
                        ]);
                    }
                    break n;
                case 2:
                    var f = r.a;
                    return _([
                        A2(Xi, f.a, A2(gf, n, f.b))
                    ]);
                case 3:
                    var o = r.a, b = o.e;
                    return A2(Tt, A4(pf, o.a, o.b, o.c, o.d), n(b));
                default:
                    return r;
            }
        }
        return A2(kr, u = r.a, A2(gf, n, r.b));
    }), mf = F4(function(n, r, t, e) {
        return {
            aC: e,
            aJ: t,
            dm: r,
            aV: n
        };
    }), wf = 3432918353, yf = 461845907, Af = F2(function(n, r) {
        return (65535 & r) * n + (((r >>> 16) * n & 65535) << 16);
    }), _f = F2(function(n, r) {
        return r << n | r >>> 32 - n;
    }), kf = M, Nf = F2(function(n, r) {
        return A2(Af, 5, A2(_f, 13, n ^ A2(Af, yf, A2(_f, 15, A2(Af, wf, r))))) + 3864292196;
    }), jf = F2(function(n, r) {
        var t, e, u = r.aJ | (255 & (55296 > (e = (t = n).charCodeAt(0)) || e > 56319 ? e : 1024 * (e - 55296) + t.charCodeAt(1) - 56320 + 65536)) << r.aV;
        return 24 === r.aV ? {
            aC: r.aC + 1,
            aJ: 0,
            dm: A2(Nf, r.dm, u),
            aV: 0
        } : {
            aC: r.aC + 1,
            aJ: u,
            dm: r.dm,
            aV: r.aV + 8
        };
    }), Of = F2(function(n, r) {
        var t, e, u, a;
        return ((a = A2(Af, 3266489909, (u = A2(Af, 2246822507, (e = ((t = A3(kf, jf, A4(mf, 0, n, 0, 0), r)).aJ ? t.dm ^ A2(Af, yf, A2(_f, 15, A2(Af, wf, t.aJ))) : t.dm) ^ t.aC) ^ e >>> 16)) ^ u >>> 13)) ^ a >>> 16) >>> 0;
    }), Lf = function(n) {
        n: for(;;)switch(n){
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "a";
            case 11:
                return "b";
            case 12:
                return "c";
            case 13:
                return "d";
            case 14:
                return "e";
            case 15:
                return "f";
            default:
                continue n;
        }
    }, Cf = F2(function(n, r) {
        for(;;){
            if (16 > r) return A2(kr, Lf(r), n);
            n = A2(kr, Lf(A2(qc, 16, r)), n), r = r / 16 | 0;
        }
    }), Rf = function(n) {
        var r;
        return A2(fe, "_", k(0 > (r = A2(Of, 15739, n)) ? A2(kr, "-", A2(Cf, w, -r)) : A2(Cf, w, r)).join(""));
    }, Tf = function(n) {
        return n.b ? Dr(n.a) : Ir;
    }, Sf = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return Dr(_([
                    n.a
                ]));
            }
            return Ir;
        }
    }, Ef = function(n) {
        var r, t = function(n) {
            return n.b ? A2(kr, n.a, t(n.b)) : w;
        };
        return _([
            (r = t(n), {
                $: 9,
                a: r
            })
        ]);
    }, Jf = function(n) {
        return _([
            n
        ]);
    }, Mf = F2(function(n, r) {
        return r.$ ? r : A2(rf, n, _([
            r.a
        ]));
    }), xf = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(kr, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Uf = F2(function(n, r) {
        return Hr(A3(xf, n, r, w));
    }), Bf = F3(function(n, r, t) {
        if (r > 0) {
            var e = h(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return _([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, c = a.b;
                                return _([
                                    a.a,
                                    c.a,
                                    c.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var i = e.b, f = i.b, o = f.b, b = o.b, s = b.b;
                                return A2(kr, i.a, A2(kr, f.a, A2(kr, o.a, A2(kr, b.a, n > 1e3 ? A2(Uf, r - 4, s) : A3(Bf, n + 1, r - 4, s)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return _([
                e.b.a
            ]);
        }
        return w;
    }), Df = F2(function(n, r) {
        return A3(Bf, 0, n, r);
    }), If = F5(function(n, r, t, e, u) {
        return u.$ ? u : A5(pf, n, r, t, e, u.a);
    }), Ff = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(rf, n, _([
                    r.a
                ]));
            case 1:
                var t = r.b;
                return A2(rf, m(n, r.a), t);
            case 2:
                var e = r.b;
                return A2(Xi, r.a, A2(Tt, Ff(n), e));
            case 3:
                return A5(pf, r.a, r.b, r.c, r.d, r.e);
            default:
                return r;
        }
    }), Qf = function(n) {
        return n;
    }, Vf = F4(function(n, r, t, e) {
        var u = function(n) {
            var r;
            return A2(me, w, (r = n).b ? Dr(r.b) : Ir);
        }, a = A2(qf, r, A2(me, w, Sf(e))), c = function() {
            var n = h(Tf(a), function(n) {
                n: for(;;){
                    if (n.b) {
                        if (n.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Dr(n.a);
                    }
                    return Ir;
                }
            }(e));
            if (n.a.$ || n.b.$) return e;
            var r = n.a.a, t = n.b.a;
            return m(A2(Df, Yr(e) - 1, e), _([
                b(t, r) ? t : r
            ]));
        }();
        return m(c, m(u(A2(me, w, A2(Wt, function(r) {
            return Pi(A2(tf, qf(n), A2(Tt, Jf, A2(gf, t, r))));
        }, Sf(e)))), u(a)));
    }), qf = F2(function(n, r) {
        if (!n.b) return r;
        switch(n.a.$){
            case 0:
                return A2(qf, c = n.b, A2(uf, n.a.a, r));
            case 1:
                var t = n.a;
                return A4(Vf, l = t.b, c = n.b, hf(t.a), r);
            case 2:
                var e = n.a, u = e.a, a = e.b, c = n.b, i = F2(function(n, r) {
                    var t = n.c, e = r.b, a = r.c;
                    return A3(Ki, n.a, m(n.b, A2(kr, h(u, r.a), e)), function(n) {
                        n: for(;;){
                            if (n.b) {
                                var r = n.a;
                                if (1 === r.$) {
                                    n = n.b;
                                    continue n;
                                }
                                return r;
                            }
                            return Ir;
                        }
                    }(_([
                        a,
                        t
                    ])));
                }), f = function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a, e = t.a, u = t.b, a = t.c, c = A2(Yi, function(n) {
                                return A2(Tt, i(n), A2(kr, e, u));
                            }, $f(r)), f = c.b ? _([
                                Wi(A3(Hi, c.a, c.b, w))
                            ]) : w;
                            return A2(qf, a, f);
                        case 1:
                            return A2(zf, n.a, n.b);
                        case 2:
                            return A2(Gf, n.a, n.b);
                        case 3:
                            var o = n.e;
                            return A2(Tt, A4(If, n.a, n.b, n.c, n.d), Pf(o));
                        case 4:
                            return _([
                                Zi(n.a)
                            ]);
                        case 5:
                            return _([
                                Gi(n.a)
                            ]);
                        case 6:
                            return _([
                                nf(n.a)
                            ]);
                        case 7:
                            return _([
                                zi(n.a)
                            ]);
                        default:
                            return Ef(n.a);
                    }
                };
                return Pi(m(_([
                    A2(qf, c, r)
                ]), A2(Tt, f, A2(Yi, Qf, a))));
            case 3:
                var o = n.a;
                return A4(Vf, l = o.b, c = n.b, ff(o.a), r);
            case 5:
                var b = n.a.a, s = (c = n.b, Rf(b));
                return A2(Oi, A2(qf, c, A2(uf, "animation-name:" + s, r)), _([
                    ji({
                        dS: b,
                        en: s
                    })
                ]));
            case 4:
                var v = n.a, d = v.a, l = v.b, $ = (c = n.b, function() {
                    var n = $f(r);
                    if (n.b) {
                        var t = n.a, e = n.b;
                        return A2(Tt, Mf(d), A2(qf, l, Jf(Wi(A3(Hi, t, e, w)))));
                    }
                    return w;
                }());
                return m(A2(qf, c, r), $);
            default:
                return A2(qf, m(n.a.a, c = n.b), r);
        }
    }), Pf = function(n) {
        return A2(qf, n.c, _([
            Wi(A3(Hi, n.a, n.b, w))
        ]));
    }, Yf = function(n) {
        if (n.b) {
            var r = n.b;
            return m(Zf(n.a), Yf(r));
        }
        return w;
    }, zf = F2(function(n, r) {
        return A2(Yi, function(r) {
            return A2(Tt, Ff(n), Pf(r));
        }, r);
    }), Gf = F2(function(n, r) {
        var t = Yf(A2(Yi, Qf, r));
        return _([
            A2(Xi, n, t)
        ]);
    }), Zf = function(n) {
        switch(n.$){
            case 0:
                return Pf(r = n.a);
            case 1:
                return A2(zf, n.a, n.b);
            case 2:
                return A2(Gf, n.a, n.b);
            case 3:
                var r = n.e;
                return A2(Tt, A4(If, n.a, n.b, n.c, n.d), Pf(r));
            case 4:
                return _([
                    Zi(n.a)
                ]);
            case 5:
                return _([
                    Gi(n.a)
                ]);
            case 6:
                return _([
                    nf(n.a)
                ]);
            case 7:
                return _([
                    zi(n.a)
                ]);
            default:
                return Ef(n.a);
        }
    }, Kf = function(n) {
        var r, t, e;
        return function(n) {
            var r = n.cR, t = n.c$, e = n.dT;
            return A2(me, "", A2(Wt, function(n) {
                return '@charset "' + n + '"';
            }, n.cA)) + (A3(Ti, Mi, "\n", r) + (A3(Ti, xi, "\n", t) + (A3(Ti, qi, "\n", e) + "")));
        }(function(n) {
            var r = n.cR, t = n.c$;
            return {
                cA: n.cA,
                dT: Ci(n.dT),
                cR: r,
                c$: t
            };
        }((t = (r = n).cR, e = r.c$, {
            cA: r.cA,
            dT: Yf(A2(Yi, Qf, r.$7)),
            cR: t,
            c$: e
        })));
    }, Hf = function(n) {
        return xn(Pn(n));
    }, Wf = function(n) {
        return {
            cA: Ir,
            cR: w,
            c$: w,
            $7: n
        };
    }, Xf = En, no = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ro = function(n) {
        return {
            $: 0,
            a: n
        };
    }, to = F2(function(n, r) {
        return ro(n + ":" + r);
    }), eo = F2(function(n, r) {
        return A2(to, n, r.U);
    }), uo = eo("height"), ao = eo("margin"), co = eo("padding"), io = D, fo = F3(function(n, r, t) {
        return {
            cm: 0,
            cy: 0,
            aH: 0,
            w: 0,
            n: 0,
            aM: 0,
            Z: 0,
            aN: 0,
            aO: 0,
            am: 0,
            an: 0,
            S: 0,
            aP: 0,
            ab: t,
            aY: 0,
            a$: r,
            bo: n,
            U: m(io(t), r)
        };
    }), oo = A2(fo, 0, "%"), bo = A2(fo, 0, "px"), so = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), vo = F2(function(n, r) {
        var t;
        return _([
            (t = A3(so, A3(Ki, r, w, Ir), w, n), {
                $: 0,
                a: t
            })
        ]);
    }), lo = (Mc = _([
        A2(F2(function(n, r) {
            return A2(vo, r, A2(of, n, w));
        }), "body, html", _([
            ao(bo(0)),
            co(bo(0)),
            uo(oo(100))
        ]))
    ]), no(A3(Hf, "span", _([
        A2(Ai, "style", "display: none;"),
        A2(Ai, "class", "elm-css-style-wrapper")
    ]), Jf(A3(Hf, "style", w, Jf(Xf(Kf(Wf(Mc))))))))), ho = F2(function(n, r) {
        return ro(n + ":" + r);
    }), $o = F3(function(n, r, t) {
        n: for(;;)switch(t.$){
            case 0:
                var e = A2(me, "", Tf(A2(qr, ":", t.a)));
                return A2(ho, r, e);
            case 1:
                return A2(ho, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-selector");
            case 2:
                return A2(ho, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-combinator");
            case 3:
                return A2(ho, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-pseudo-element setter");
            case 4:
                return A2(ho, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-media-query");
            case 5:
                return A2(ho, r, "elm-css-error-cannot-apply-" + n + "-with-inapplicable-Style-for-keyframes");
            default:
                if (t.a.b) {
                    if (t.a.b.b) {
                        t = {
                            $: 6,
                            a: t.a.b
                        };
                        continue n;
                    }
                    t = t.a.a;
                    continue n;
                }
                return A2(ho, r, "elm-css-error-cannot-apply-" + n + "-with-empty-Style");
        }
    }), po = A3(fo, 0, "", 0), go = function(n) {
        return A3($o, "alignItems", "align-items", n(po));
    }, mo = A2(Tt, kt, Cr(ku)), wo = function(n) {
        return n.N + n.bY;
    }, yo = function(n) {
        return n.O + n.bZ;
    }, Ao = F2(function(n, r) {
        var t = r.aU, e = r.aT, u = yo(n), a = u - A2(qc, e, u), c = wo(n), i = c - A2(qc, t, c);
        return h(function(n) {
            return n.N;
        }(n) - i, function(n) {
            return n.O;
        }(n) - a);
    }), _o = eo("center"), ko = function(n) {
        return n.bu;
    }, No = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), jo = sf(_([
        {
            $: 0,
            a: "\x07"
        }
    ])), Oo = F2(function(n, r) {
        var t = r.aU, e = r.aT, u = r.ar, a = yo(n), c = wo(n), i = A5(ni, u, t, e, c, a);
        return A3(Me, i.a, i.b, u);
    }), Lo = A2(to, "display", "flex"), Co = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ro = Co("div"), To = c, So = F3(function(n, r, t) {
        var e = t.c, u = t.d, a = F2(function(r, t) {
            return A3(To, r.$ ? n : a, t, r.a);
        });
        return A3(To, n, A3(To, a, r, e), u);
    }), Eo = F2(function(n, r) {
        return A3(So, un(n), [], r);
    }), Jo = tn, Mo = f, xo = F2(function(n, r) {
        var t = r.d, e = function(r) {
            return r.$ ? ct(A2(Mo, n, r.a)) : bt(A2(Mo, e, r.a));
        };
        return A4(Xr, r.a, r.b, A2(Mo, e, r.c), A2(Mo, n, t));
    }), Uo = function(n) {
        return A2(Eo, Jo, A2(xo, function(n) {
            switch(n){
                case 0:
                    return 0;
                case 1:
                    return 1;
                default:
                    return 2;
            }
        }, n.D));
    }, Bo = function(n) {
        return A3(Pr, F2(function(n, r) {
            return A3(en, n.a, n.b, r);
        }), {}, n);
    }, Do = function(n) {
        return n.c;
    }, Io = function(n) {
        var r;
        return Bo(_([
            h("width", Jo((r = n, r.a))),
            h("pixels", Uo(Do(n)))
        ]));
    }, Fo = function(n) {
        var r = n.O, t = n.dI;
        return Bo(_([
            h("x", Jo(n.N)),
            h("y", Jo(r)),
            h("bitmapIndex", Jo(t))
        ]));
    }, Qo = tn, Vo = function(n) {
        var r = function(n) {
            return {
                dB: n.d,
                dJ: n.c,
                d1: n.b,
                eC: n.a
            };
        }(n), t = r.d1, e = r.dJ, u = r.dB;
        return Bo(_([
            h("red", Qo(r.eC)),
            h("green", Qo(t)),
            h("blue", Qo(e)),
            h("alpha", Qo(u))
        ]));
    }, qo = function(n) {
        return A2(Fn, "height", Qr(n));
    }, Po = F2(function(n, r) {
        return A3(Pr, un(n), [], r);
    }), Yo = Hf, zo = F2(function(n, r) {
        return A2(In, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && qn.test(n) ? "" : n;
        }(r));
    }), Go = zo, Zo = F4(function(n, r, t, e) {
        return A4(ta, n, r, t, e);
    }), Ko = A4(Zo, 0, 0, 0, 0), Ho = F6(function(n, r, t, e, u, a) {
        var c, i = A2(Po, Vo, _([
            t.cC,
            t.cY,
            Ko
        ])), f = A2(Po, Io, e), o = A2(Po, Fo, u);
        return A3(Yo, "pixel-renderer", m(_([
            (c = n, A2(Fn, "width", Qr(c))),
            qo(r),
            A2(Go, "colors", i),
            A2(Go, "bitmaps", f),
            A2(Go, "bitmapStamps", o)
        ]), a), w);
    }), Wo = no, Xo = F2(function(n, r) {
        return A3(F3(function(n, r, t) {
            for(;;){
                var e = pi(r);
                if (0 > d(n, e)) return r;
                if (!t.b) return r;
                n -= e, r = t.a, t = t.b;
            }
        }), n, r.a, r.b);
    }), nb = F2(function(n, r) {
        return n + "(" + A2(Vr, ",", r) + ")";
    }), rb = 3.141592653589793, tb = function(n) {
        return 0 > n ? -n : n;
    }, eb = F2(function(n, r) {
        var t = it(n);
        return A2(qc, r, t) + n - t;
    }), ub = F3(function(n, r, t) {
        var e = n / 1.0471975511965976, u = (1 - tb(2 * t - 1)) * r, a = t - u / 2, c = u * (1 - tb(A2(eb, e, 2) - 1)), i = 0 > e ? $(0, 0, 0) : 1 > e ? $(u, c, 0) : 2 > e ? $(c, u, 0) : 3 > e ? $(0, u, c) : 4 > e ? $(0, c, u) : 5 > e ? $(c, 0, u) : 6 > e ? $(u, 0, c) : $(0, 0, 0);
        return $(i.a + a, i.b + a, i.c + a);
    }), ab = F5(function(n, r, t, e, u) {
        var a = A3(ub, 180 * r / rb, t, e), c = a.a, i = a.b;
        return {
            dB: u,
            dJ: it(a.c),
            Q: 0,
            d1: it(i),
            eC: it(c),
            U: n
        };
    }), cb = function(n) {
        return io(100 * n) + "%";
    }, ib = F3(function(n, r, t) {
        var e = _([
            io(n),
            cb(r),
            cb(t)
        ]);
        return A5(ab, A2(nb, "hsl", e), n, r, t, 1);
    }), fb = F3(function(n, r, t) {
        return A3(Pr, F2(function(r, t) {
            var e = t.a;
            return h(e + 1, A3(n, e, r, t.b));
        }), h(0, r), t).b;
    }), ob = F3(function(n, r, t) {
        var e = t.M, u = t.D;
        return A3(fb, F3(function(r, t, u) {
            var a = r / e | 0;
            return A4(n, A2(qc, e, r), a, t, u);
        }), r, function(n) {
            return A3(jr, kr, w, n);
        }(u));
    }), bb = F3(function(n, r, t) {
        return A2(Vr, r, A2(qr, n, t));
    }), sb = F3(function(n, r, t) {
        return A5(ri, t.ar, t.aU, t.aT, n, r);
    }), vb = Dn, db = function(n) {
        return n.a_;
    }, lb = function(n) {
        return A2(me, Ke, A2(fa, n, ku));
    }, hb = eo("width"), $b = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pb = F2(function(n, r) {
        var t = n.c;
        return n.b && A2(fa, t, r).$ ? A3(eu, t, Rf(t), r) : r;
    }), gb = tn, mb = F2(function(n, r) {
        var t = r.a;
        if (r.b) {
            var e = A2(fa, r.c, n);
            return A2(zo, "className", gb(e.$ ? "_unstyled" : e.a));
        }
        return t;
    }), wb = F2(function(n, r) {
        var t = r.a;
        if (r.b) {
            var e = A2(fa, r.c, n);
            return A2(Ai, "class", e.$ ? "_unstyled" : e.a);
        }
        return t;
    }), yb = function(n) {
        return Bn(Pn(n));
    }, Ab = F2(function(n, r) {
        return A2(Un, n, Pn(r));
    }), _b = F2(function(n, r) {
        return A2(Mn, n, Pn(r));
    }), kb = F2(function(n, r) {
        var t = n.a, e = n.b, u = r.a, a = r.b;
        switch(e.$){
            case 4:
                return h(A2(kr, h(t, b = e.a), u), a);
            case 0:
                var c = e.a, i = e.c, f = A3(Pr, Nb, h(w, A3(Pr, pb, a, l = e.b)), i), o = f.a, b = A3(Hf, c, A2(Tt, mb($ = f.b), l), Hr(o));
                return h(A2(kr, h(t, b), u), $);
            case 1:
                var s = e.a, v = (c = e.b, i = e.d, A3(Pr, Nb, h(w, A3(Pr, pb, a, l = e.c)), i));
                return o = v.a, b = A4(_b, s, c, A2(Tt, mb($ = v.b), l), Hr(o)), h(A2(kr, h(t, b), u), $);
            case 2:
                c = e.a, i = e.c;
                var d = A3(Pr, kb, h(w, A3(Pr, pb, a, l = e.b)), i);
                return o = d.a, b = A3(yb, c, A2(Tt, mb($ = d.b), l), Hr(o)), h(A2(kr, h(t, b), u), $);
            default:
                s = e.a, c = e.b, i = e.d;
                var l, $, p = A3(Pr, kb, h(w, A3(Pr, pb, a, l = e.c)), i);
                return o = p.a, b = A4(Ab, s, c, A2(Tt, mb($ = p.b), l), Hr(o)), h(A2(kr, h(t, b), u), $);
        }
    }), Nb = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 4:
                return h(A2(kr, f = n.a, t), e);
            case 0:
                var u = n.a, a = n.c, c = A3(Pr, Nb, h(w, A3(Pr, pb, e, v = n.b)), a), i = c.a, f = A3(Hf, u, A2(Tt, mb(d = c.b), v), Hr(i));
                return h(A2(kr, f, t), d);
            case 1:
                var o = n.a, b = (u = n.b, a = n.d, A3(Pr, Nb, h(w, A3(Pr, pb, e, v = n.c)), a));
                return i = b.a, f = A4(_b, o, u, A2(Tt, wb(d = b.b), v), Hr(i)), h(A2(kr, f, t), d);
            case 2:
                u = n.a, a = n.c;
                var s = A3(Pr, kb, h(w, A3(Pr, pb, e, v = n.b)), a);
                return i = s.a, f = A3(yb, u, A2(Tt, mb(d = s.b), v), Hr(i)), h(A2(kr, f, t), d);
            default:
                o = n.a, u = n.b, a = n.d;
                var v, d, l = A3(Pr, kb, h(w, A3(Pr, pb, e, v = n.c)), a);
                return i = l.a, f = A4(Ab, o, u, A2(Tt, wb(d = l.b), v), Hr(i)), h(A2(kr, f, t), d);
        }
    }), jb = F3(function(n, r, t) {
        return t + "\n" + A3(bb, "\x07", r, n);
    }), Ob = F2(function(n, r) {
        return A3(Fe, F3(function(r, t, e) {
            return e + "\n" + A3(bb, ".\x07", "#" + n + "." + t, r);
        }), "", r);
    }), Lb = F2(function(n, r) {
        var t = function() {
            if (r.$) {
                var n = r.a, t = r.c;
                return A2(Ob, n, r.b) + "\n" + A2(Ob, n + " ", t);
            }
            return A3(Fe, jb, "", r.a);
        }();
        return A3(Hf, "span", _([
            A2(Ai, "style", "display: none;"),
            A2(Ai, "class", "elm-css-style-wrapper")
        ]), _([
            A3(Hf, "style", n.$ ? w : _([
                A2(Ai, "nonce", n.a)
            ]), Jf(Xf(t)))
        ]));
    }), Cb = F4(function(n, r, t, e) {
        var u = A3(Pr, Nb, h(w, A3(Pr, pb, We, t)), e), a = u.a, c = u.b, i = A2(Lb, n, $b(c)), f = A2(Tt, mb(c), t);
        return A3(Hf, r, f, A2(kr, i, Hr(a)));
    }), Rb = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (b(n, r.a.a)) return !0;
            r = t;
        }
    }), Tb = F2(function(n, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, e = "_" + r.a.a;
                if (A2(Rb, e, t)) {
                    n = e, r = t;
                    continue n;
                }
                return e;
            }
            return n;
        }
    }), Sb = F3(function(n, r, t) {
        return h(A2(Tb, "_", t), A2(Lb, n, r));
    }), Eb = F4(function(n, r, t, e) {
        var u = A3(Pr, kb, h(w, A3(Pr, pb, We, t)), e), a = u.a, c = u.b, i = A3(Sb, n, $b(c), a), f = A2(Tt, mb(c), t);
        return A3(yb, r, f, A2(kr, i, Hr(a)));
    }), Jb = F5(function(n, r, t, e, u) {
        var a = A3(Pr, kb, h(w, A3(Pr, pb, We, e)), u), c = a.a, i = a.b, f = A3(Sb, n, $b(i), c), o = A2(Tt, wb(i), e);
        return A4(Ab, r, t, o, A2(kr, f, Hr(c)));
    }), Mb = F5(function(n, r, t, e, u) {
        var a = A3(Pr, Nb, h(w, A3(Pr, pb, We, e)), u), c = a.a, i = a.b, f = A2(Lb, n, $b(i)), o = A2(Tt, wb(i), e);
        return A4(_b, r, t, o, A2(kr, f, Hr(c)));
    }), xb = function(n) {
        switch(n.$){
            case 4:
                return n.a;
            case 0:
                return A4(Cb, Ir, n.a, n.b, n.c);
            case 1:
                return A5(Mb, Ir, n.a, n.b, n.c, n.d);
            case 2:
                return A4(Eb, Ir, n.a, n.b, n.c);
            default:
                return A5(Jb, Ir, n.a, n.b, n.c, n.d);
        }
    }, Ub = Qt({
        d9: function(n) {
            var r;
            return h({
                a6: A3(ra, 16, 136 + 22 * (r = nc, Ht(r.ar) - 1) * 8, A2(Hu, p(rc, {
                    aL: 1,
                    dg: 1,
                    bO: 2
                }), Gu)),
                al: Zu,
                bJ: Xu(n.ck),
                bQ: nc
            }, na);
        },
        eR: function() {
            var n;
            return ic(_([
                (n = F2(function(n, r) {
                    return {
                        $: 1,
                        a: A2(cc, n, r)
                    };
                }), A3(Bc, 1, "resize", A2(Vt, "target", A3(yt, n, A2(Vt, "innerWidth", tc), A2(Vt, "innerHeight", tc))))),
                A2(kc, 1e3 / 60, function() {
                    return ac;
                }),
                Dc(bc(ec)),
                Ic(bc(uc))
            ]));
        },
        eX: yi,
        eZ: function(n) {
            var r, t, e, u, a, c, i, f, o, b, s, v, d, l, $, p, g, m;
            return {
                dL: A2(Tt, xb, _([
                    lo,
                    (a = n, f = a.bQ, o = a.a6, b = a.bJ, s = A2(me, A2(ia, 22, 22), A2(Wt, db, A2(Oo, o, f))), v = A3(ob, F4(function(n, r, t, e) {
                        return A2(kr, {
                            dI: t,
                            N: 8 * n,
                            O: 8 * r
                        }, e);
                    }), w, function(n) {
                        return n.cj;
                    }(s)), d = _([
                        A2(vb, "transform", A3(bb, "{scale}", Qr(b), "scale({scale})"))
                    ]), l = A2(me, ea, A2(Wt, ko, A3(sb, wo(o), yo(o), f))), $ = A2(Ao, o, f), p = $.a, g = $.b, m = {
                        dI: (e = o, (u = function(n) {
                            var r = n.bi, t = h(n.bg, n.aG);
                            if (1 === t.b) switch(t.a){
                                case 0:
                                    return r.eP;
                                case 1:
                                    return r.eK;
                                default:
                                    return r.ec;
                            }
                            else switch(t.a){
                                case 0:
                                    return r.eO;
                                case 1:
                                    return r.eJ;
                                default:
                                    return r.eb;
                            }
                        }(e)).$ ? A2(Xo, u.a, u.b).b : u.a),
                        N: p,
                        O: g
                    }, A2(Ro, _([
                        (r = _([
                            Lo,
                            (i = _o, A3($o, "justifyContent", "justify-content", i(po))),
                            go(_o),
                            uo(oo(100)),
                            hb(oo(100)),
                            ao(bo(0)),
                            co(bo(0)),
                            (c = A3(ib, 0, 0, .97), A2(to, "background-color", c.U))
                        ]), t = function(n) {
                            return n.b ? Kf(Wf(_([
                                A2(vo, n, jo)
                            ]))) : "";
                        }(r), A3(No, A2(Ai, "", ""), !0, t))
                    ]), _([
                        Wo(A6(Ho, 176, 176, l, A2(Tt, lb, mo), Hr(A2(kr, m, v)), d))
                    ])))
                ])),
                eU: "Tielmaps"
            };
        }
    });
    xc = {
        Main: {
            init: Ub(A2(mt, function(n) {
                return At({
                    ck: n
                });
            }, A2(Vt, "viewport", A2(mt, function(n) {
                return A2(mt, function(r) {
                    return At({
                        d3: r,
                        e_: n
                    });
                }, A2(Vt, "height", tc));
            }, A2(Vt, "width", tc)))))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? o(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, xc) : n.Elm = xc;
}($c1e53a68f7465bc4$exports);


if (!window["customElements"]) throw new Error("window.customElements does not exist. Please use an appropriate polyfill");
const $2128dbec3d612b3a$var$getPixel = (width, x, y, pixels)=>{
    return pixels[x + width * y] ?? -1;
};
class $2128dbec3d612b3a$var$PixelRendererElement extends HTMLElement {
    static get observedAttributes() {
        return [
            "width",
            "height"
        ];
    }
    /**
   * Run when the element is put on the page. We prepare stuff here.
   */ connectedCallback() {
        if (this.canvas && this.context) return;
        // Create the child `<canvas>`.
        this.canvas = document.createElement("canvas");
        this.appendChild(this.canvas);
        this.canvas.style.display = "flex";
        this.canvas.style.imageRendering = "pixelated";
        // The 2D context is the actual interface we use to paint the canvas.
        const context = this.canvas.getContext("2d");
        if (!context) throw new Error("Could not get 2D context from canvas element.");
        this.context = context;
        this.updateStyles();
        this.paintCanvas();
    }
    /**
   * Run whenever the element's attributes get changed.
   */ attributeChangedCallback(name, oldValue, newValue) {
        if ((name === "width" || name === "height") && oldValue !== newValue) this.updateStyles();
    }
    set bitmaps(bitmaps) {
        this.bitmaps_ = bitmaps;
    }
    set bitmapStamps(tileStamps) {
        this.bitmapStamps_ = tileStamps;
        this.paintCanvas();
    }
    /**
   * Updates dimensions of the child `<canvas>` element according to values set
   * via attributes.
   */ updateStyles() {
        if (!this.canvas) return;
        const width = Number(this.getAttribute("width"));
        const height = Number(this.getAttribute("height"));
        this.canvas.style.width = width + "px";
        this.canvas.style.height = height + "px";
        this.canvas.width = width;
        this.canvas.height = height;
    }
    async paintCanvas() {
        const context = this.context;
        if (!this.canvas || !context) return;
        const tileImages = await Promise.all(this.bitmaps_.map($2128dbec3d612b3a$var$bitmapToImage(context, this.colors)));
        this.bitmapStamps_.forEach(({ x: x, y: y, bitmapIndex: tileIndex })=>{
            const tileImage = tileImages[tileIndex];
            if (!tileImage) return;
            if (tileImage instanceof ImageBitmap) context.drawImage(tileImage, x, y);
            else context.putImageData(tileImage, x, y);
        });
    }
    constructor(...args){
        super(...args);
        this.bitmapStamps_ = [];
        this.bitmaps_ = [];
        this.colors = [];
    }
}
const $2128dbec3d612b3a$var$bitmapToImage = (context, colors)=>async ({ width: width, pixels: pixels })=>{
        const height = Math.ceil(pixels.length / width);
        const imageData = context.createImageData(width, height);
        let hasTransparency = false;
        if (!imageData) return;
        for(let x = 0; x < width; x += 1)for(let y = 0; y < height; y += 1){
            const offset = x * 4 + width * 4 * y;
            const pixel = $2128dbec3d612b3a$var$getPixel(width, x, y, pixels);
            const color = colors[pixel];
            imageData.data[offset + 0] = (color?.red ?? 0) * 0xff;
            imageData.data[offset + 1] = (color?.green ?? 0) * 0xff;
            imageData.data[offset + 2] = (color?.blue ?? 0) * 0xff;
            imageData.data[offset + 3] = (color?.alpha ?? 1) * 0xff;
            if ((color?.alpha ?? 1) < 1) hasTransparency = true;
        }
        if (hasTransparency) return await createImageBitmap(imageData);
        return imageData;
    };
customElements.define("pixel-renderer", $2128dbec3d612b3a$var$PixelRendererElement);


const $a246a0863498a088$var$app = (0, $c1e53a68f7465bc4$exports.Elm).Main.init({
    node: document.getElementById("elm"),
    flags: {
        viewport: {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }
});

})();
//# sourceMappingURL=index.b653ca52.js.map
